/**
 * OTP NAV
 * ___________________________ */

let subnavitems = document.querySelectorAll(".dz-otpnav-item");
const navWrapper = document.querySelector(".dz-global-nav-wrap");
subnavitems.forEach((item) => {
  item.addEventListener("mouseenter", openSubnav);
});
if (navWrapper) {
  navWrapper.addEventListener("mouseenter", function () {
    var cActive = document.querySelector(".dz-otpnav-item.open");
    if (cActive) {
      cActive.classList.remove("open");
    }
    var cOpen = document.querySelector(".dz-otpsubnav.show");
    if (cOpen) {
      cOpen.classList.remove("show");
    }
  });
}
window.getGiftVariantId = function () {
  const raw =
    (window.itemOBToAddId != null ? String(window.itemOBToAddId).trim() : "") ||
    "53298337710446";

  const id = Number(raw);
  return Number.isFinite(id) ? id : 53298337710446;
};


function openSubnav(e) {
  var cActive = document.querySelector(".dz-otpnav-item.open");
  if (cActive) {
    cActive.classList.remove("open");
  }
  e.target.classList.add("open");
  if (e.target.id != "") {
    let openDiv = document.querySelector(".dz-otpsubnav.show");
    if (openDiv != null) {
      openDiv.classList.remove("show");
    }
    let div = document.querySelector(`[data-target=${e.target.id}]`);
    if (div != null) {
      div.classList.add("show");
      div.addEventListener("mouseleave", hideSubnav);
    }
  } else {
    var cOpen = document.querySelector(".dz-otpsubnav.show");
    if (cOpen) {
      cOpen.classList.remove("show");
    }
  }
}

function hideSubnav(e) {
  e.target.classList.remove("show");
  document.querySelector(".dz-otpnav-item.open").classList.remove("open");
  e.target.removeEventListener("mouseleave", hideSubnav);
}

function hideAllSubnavs() {
  if (document.querySelector(".dz-otpsubnav.show")) {
    document.querySelector(".dz-otpsubnav.show").classList.remove("show");
  }
}

/**
 * MOBILE NAV
 * ___________________________ */

let navTrigger = document.querySelector("#dz-mobile-nav-trigger");
console.log("Mobile nav trigger: ", navTrigger);
navTrigger.addEventListener("click", triggerMobileNav);
let backdrop = document.querySelector(".dz-backdrop");
if (backdrop) {
  backdrop.addEventListener("click", triggerMobileNav);
}

function triggerMobileNav(e) {
  console.log("Mobile nav clicked!");
  let mobileNav = document.querySelector("#dz-mobile-nav");
  let body = document.querySelector("body");
  if (!mobileNav) {
    //console.log('no nav found')
    return;
  }
  if (!backdrop) {
    //console.log('no backdrop found')
    return;
  }

  if (mobileNav.classList.contains("open")) {
    // close nav
    mobileNav.classList.remove("open");
    backdrop.classList.remove("open");

    setTimeout(() => {
      backdrop.classList.remove("opens");
      body.classList.remove("overflowHidden");
    }, 500);
  } else {
    // open nav
    mobileNav.classList.add("open");
    backdrop.classList.add("opens");
    body.classList.add("overflowHidden");
    setTimeout(() => {
      backdrop.classList.add("open");
    }, 300);
  }
}

/**
 * MOBILE SEARCH DRAWER
 * ___________________________ */

function openSearchDrawer() {
  // console.log('opensearchdrawer')
  let body = document.querySelector("body");
  //js-drawer-open js-drawer-open-top
  body.classList.add("js-drawer-open");
  body.classList.add("js-drawer-open-top");
  body.classList.add("overflowHidden");
}
function closeSearchDrawer() {
  // console.log('closesearchdrawer')
  let body = document.querySelector("body");
  //js-drawer-open js-drawer-open-top
  body.classList.remove("js-drawer-open");
  body.classList.remove("js-drawer-open-top");
  body.classList.remove("overflowHidden");
}

/**
 * PRODUCTLISTS
 * ___________________________ */

let variantbtns = document.querySelectorAll(".dz-variantselect-selected");
let variantcontainers = document.querySelectorAll(
  "[data-dz-variantselect-options]"
);
let variantoptions = document.querySelectorAll(".dz-variantselect-option");

// variantbtns.forEach(variantbtn=>{
//     variantbtn.addEventListener('click', showVariants)
// })

// variantoptions.forEach(variantoption=>{
//     variantoption.addEventListener('click', selectVariant)
// })

function showVariants(id) {
  // console.log(id)
  // SHOW VARIANTCONTAINER for clicked variantbtn
  let variantContainer = document.querySelector(`[data-target=${id}]`);
  if (variantContainer.classList.contains("show")) {
    variantContainer.classList.remove("show");
  } else {
    variantContainer.classList.add("show");
  }
}

function hideVariants(e) {
  //console.log(e.target)
  e.target.classList.remove("show");
}

function selectVariant(e) {
  // console.log(e)
  let varId = e.target.id.split("-")[1];
  let proId = e.target.id.split("-")[0].replace("_", "-");
  // console.log(varId)
  // console.log(proId)
  // console.log(e.target.textContent)

  // GET CURRENT CARD
  let cCard = document.querySelector(`#productcard-${proId}`);

  // CHANGE FEATURED IMAGE
  let cImage = cCard.querySelector("img.dz-visible");
  let targetImage = cCard.querySelector(`#variant-image-${varId}`);
  if (cImage && targetImage) {
    cImage.classList.remove("dz-visible");
    cImage.classList.add("dz-hidden");
    targetImage.classList.add("dz-visible");
    targetImage.classList.remove("dz-hidden");
  }

  // CHANGE VARIANT TITLE TEXT
  let variantTitle = cCard.querySelector(".dz-variantselect-selectedvalue");
  variantTitle.textContent = e.target.textContent;

  // CHANGE VARIANT PRICE
  let cPrice = cCard.querySelector("span.dz-visible");
  let targetPrice = cCard.querySelector(`#variant-price-${varId}`);
  if (cPrice && targetPrice) {
    cPrice.classList.remove("dz-visible");
    cPrice.classList.add("dz-hidden");
    targetPrice.classList.add("dz-visible");
    targetPrice.classList.remove("dz-hidden");
  }

  // CHANGE VARIANT BASEPRICE

  let cBase = cCard.querySelector(
    "span.dz-visible.dz-variantselect-baseprices"
  );
  let targetBase = cCard.querySelector(`#variant-baseprice-${varId}`);
  if (cBase && targetBase) {
    cBase.classList.remove("dz-visible");
    cBase.classList.add("dz-hidden");
    targetBase.classList.add("dz-visible");
    targetBase.classList.remove("dz-hidden");
  }

  // CHANGE VARIANT INSTOCK MESSAGE
  let cStock = cCard.querySelector("span.dz-visible.dz-variantselect-stocks");
  let targetStock = cCard.querySelector(`#variant-stock-${varId}`);

  if (cStock && targetStock) {
    cStock.classList.remove("dz-visible");
    cStock.classList.add("dz-hidden");
    targetStock.classList.add("dz-visible");
    targetStock.classList.remove("dz-hidden");
  }

  // CHANGE BOLDSELECTION
  let cSelected = cCard.querySelector("dd.dz-selected");
  let targetSelected = cCard.querySelector("dd:not(.dz-selected)");
  if (cSelected && targetSelected) {
    cSelected.classList.remove("dz-selected");
    targetSelected.classList.add("dz-selected");
  }

  // CHANGE BUYBUTTONS
  let cBtn = cCard.querySelector(".dz-cart-btns.dz-visible");
  let targetBtns = cCard.querySelector(`#variant-cartbtn-${varId}`);
  if (cBtn && targetBtns) {
    cBtn.classList.remove("dz-visible");
    cBtn.classList.add("d-none");
    targetBtns.classList.add("dz-visible");
    targetBtns.classList.remove("d-none");
  }

  // CHANGE SELECTION
  let select = cCard.querySelector(`#productSelect-${proId}`);
  // console.log('varId', varId);
  // console.log(select.value)
  select.value = varId;
  // console.log(select.value)

  // close Options on SELECT
  let optionsContainer = cCard.querySelector("[data-dz-variantselect-options]");
  if (optionsContainer) {
    optionsContainer.classList.remove("show");
  }
}

/**
 * LOGIN POPUP
 * ___________________________ */
// document.addEventListener('click', closeLoginPopup)
let loginIcons = document.querySelectorAll("#dz-customer-login");
loginIcons.forEach((loginIcon) => {
  loginIcon.addEventListener("click", showLoginModal);
});
$(document).click(function (event) {
  var $target = $(event.target);
  let loginModal = document.querySelector(
    `[data-target=${"dz-customer-login"}]`
  );
  if (!loginModal) {
    return;
  }
  if (
    !$target.closest(`[data-target=${"dz-customer-login"}]`).length &&
    !$target.closest(`#dz-customer-login`).length &&
    loginModal.classList.contains("show")
  ) {
    //console.log('close')
    loginModal.classList.remove("show");
  }
});
function showLoginModal(e) {
  e.preventDefault();
  let loginModal = document.querySelector(
    `[data-target=${"dz-customer-login"}]`
  );
  if (loginModal) {
    if (loginModal.classList.contains("show")) {
      loginModal.classList.remove("show");
    } else {
      loginModal.classList.add("show");
    }
  }
}

// function closeLoginPopup(e){
//     console.log(e)
//     var $target =
// }

/**
 * CART POPUP
 * ___________________________ */

let cartIcons = document.querySelectorAll("#dz-cart-selector");
cartIcons.forEach((cartIcon) => {
  cartIcon.addEventListener("click", showCartModal);
});

$(document).click(function (event) {
  var $target = $(event.target);
  let cartModal = document.querySelector(`[data-target=${"dz-cart-selector"}]`);

  if (
    !$target.closest(`[data-target=${"dz-cart-selector"}]`).length &&
    !$target.closest(`#dz-cart-selector`).length &&
    cartModal.classList.contains("show")
  ) {
    //console.log('close')
    cartModal.classList.remove("show");
  }
});

function showCartModal(e) {
  e.preventDefault();
  let cartModal = document.querySelector(`[data-target=${"dz-cart-selector"}]`);
  if (cartModal) {
    if (cartModal.classList.contains("show")) {
      cartModal.classList.remove("show");
    } else {
      cartModal.classList.add("show");
    }
  }
}

function prevent(e, k) {
  //console.log('prevent',e)
  //console.log('index',k)
  //  fetch('/cart/change.js',{
  //      method:'POST',
  //      body:JSON.stringify({
  //          'line':1,
  //          'quantity':2
  //      })
  //  }
  //  )
  // jQuery.get({
  //     url:'/cart.js',
  //     dataType: 'json'
  // }).done(function(res){
  //     console.log('cart',res)
  // })

  // jQuery.getJSON('/cart.js', function(cart) {
  //     // now have access to Shopify cart object
  //     console.log(cart)
  //     alert('There are now ' + cart.item_count + ' items in the cart.');
  //  } );
  jQuery.get(
    "/cart.js",
    function (data) {
      console.log("test", data);
    },
    "json"
  );
  jQuery.post(
    "/cart/change.js",
    {
      line: k,
      quantity: 2,
    },
    function (data) {
      //console.log('res',data)
    },
    "json"
  );
}


/**
 * KEENSLIDER
 */

/**
 * KEENSLIDER
 * ___________________________ */

var elements = document.querySelectorAll(".fader__slide");
if (elements.length > 0) {
  var sliderElement = document.getElementById("my-keen-slider");

  var interval = 0;
  function autoplay(run) {
    clearInterval(interval);
    interval = setInterval(() => {
      if (run && slider) {
        slider.next();
        // check if at last slide
        if (slider.details().relativeSlide === slider.details().size - 1) {
          slider.moveToSlide(0); // wrap around manually
        } else {
          slider.next();
        }
      }
    }, 5000);
  }
  var slider = new KeenSlider("#my-keen-slider", {
    slides: elements.length,
    loop: false,
    duration: 1000,
    dragStart: () => {
      autoplay(false);
    },
    dragEnd: () => {
      autoplay(true);
    },
    move: (s) => {
      var opacities = s.details().positions.map((slide) => slide.portion);
      elements.forEach((element, idx) => {
        element.style.opacity = opacities[idx];
      });
    },
    afterChange: (slider) => {
      //var allSlides = document.querySelectorAll('[data-dz-slider-link]')
      //var link = allSlides[slider.details().relativeSlide].dataset.dzSliderLink
      //var aTag = document.querySelector('[data-dz-slideshow-link]')
      //aTag.href = link

      var allSlides = document.querySelectorAll(
        "#my-keen-slider .keen-slider__slide"
      );
      var cur_ele = allSlides[slider.details().relativeSlide];
      if (cur_ele.classList.contains("video-slide")) {
        var cur_short_video = cur_ele.querySelector(".slider-shortvideo");
        var cur_full_video = cur_ele.querySelector(".slider-fullvideo");
        var play_btn = cur_ele.querySelector(".play-button");
        if (play_btn) {
          play_btn.addEventListener("click", function () {
            play_btn.classList.add("hide");
            cur_short_video.classList.add("hide");
            cur_full_video.classList.remove("hide");
            cur_full_video.play();
          });
        }
      }
    },
created: function (instance) {
  if (!document.getElementById("my-keen-slider")) {
    return;
  }

  var dots_wrapper = document.getElementById("dots");

  // Clear any existing dots first
  dots_wrapper.innerHTML = "";

  // Only count slides inside this slider
  var slides = document.querySelectorAll(
    "#my-keen-slider .keen-slider__slide"
  );

  slides.forEach(function (t, idx) {
    var dot = document.createElement("button");
    dot.classList.add("dot");

    dot.addEventListener("click", function () {
      instance.moveToSlide(idx);
    });

    dots_wrapper.appendChild(dot);
  });

  updateClasses(instance);

  let autoplayInlineVideos = document.querySelectorAll(
    ".hero-slider-video.slider-shortvideo.autoplay-inline"
  );

  autoplayInlineVideos.forEach((vid) => {
    vid.addEventListener("ended", function () {
      // Stop current autoplay
      autoplay(false);

      // Move to first slide
      instance.moveToSlide(1);
      instance.next();

      // Restart autoplay
      autoplay(true);
    });
  });
},
    slideChanged(instance) {
      var allSlides = document.querySelectorAll(
        "#my-keen-slider .keen-slider__slide"
      );

      allSlides.forEach(function (slide) {
        var videos = slide.querySelectorAll("video");
        videos.forEach(function (video) {
          video.pause();
        });
      });
      for (const slide of allSlides) {
        slide.classList.remove("zindex1");
      }
      allSlides[instance.details().relativeSlide].classList.add("zindex1");

      var currentSlide = allSlides[instance.details().relativeSlide];
      if (currentSlide.classList.contains("video-slide")) {
        var video = currentSlide.querySelector("video");
        if (video) {
          video.play();
          autoplay(false);
        }
      }

      updateClasses(instance);
    },
  });

  sliderElement.addEventListener("mouseover", () => {
    autoplay(false);
  });
  sliderElement.addEventListener("mouseout", () => {
    autoplay(true);
  });
  // autoplay(true);
}

var productslider = new KeenSlider("#my-keen-slider-product", {
  created: function (instance) {
    // console.log(instance)
    if (!document.getElementById("my-keen-slider-product")) {
      return;
    }
    var counter = document.getElementById("dz-current-image-count");
    if (counter) {
      counter.innerText = 1;
    }
  },
  slideChanged: (slider) => {
    var counter = document.getElementById("dz-current-image-count");
    if (counter) {
      if (slider.details().relativeSlide) {
        counter.innerText = slider.details().relativeSlide + 1;
      } else {
        counter.innerText = 1;
      }
    }
  },
});

function updateClasses(instance) {
  var slide = instance.details().relativeSlide;

  var dots = document.querySelectorAll(".dot");
  dots.forEach(function (dot, idx) {
    idx === slide
      ? dot.classList.add("dot--active")
      : dot.classList.remove("dot--active");
  });
}

function changeVariant(e, selector, i) {
  console.log("👉 changeVariant triggered", { text: e.target.textContent, selector, i });

  // --- BASIC VARIANT UI ---
  var sel = document.getElementById(selector);
  var variantOptions = Array.from(document.querySelectorAll("[data-dz-variant-option]"));
  console.log("Found variant options:", variantOptions.length);

  if (variantOptions) {
    variantOptions.forEach((option) => {
      if (option.dataset.dzVariantOption != i) {
        option.classList.remove("text-decoration-underline", "fw-900");
      } else {
        option.classList.add("text-decoration-underline", "fw-900");
      }
    });
  }

  if (sel) {
    sel.value = e.target.textContent.trim();
    sel.dispatchEvent(new Event("change"));
    console.log("Updated selector value:", sel.value);
  }

  var oliveMaimSel = document.getElementById("ProductSelect-olive-main");
  if (oliveMaimSel) {
    var omOptions = oliveMaimSel.querySelectorAll("option");
    omOptions.forEach(function (option) {
      if (option.dataset.value == e.target.textContent.trim()) {
        option.setAttribute("selected", "selected");
      } else {
        option.removeAttribute("selected");
      }
    });
    oliveMaimSel.dispatchEvent(new Event("change"));
    console.log("Dispatched change on ProductSelect-olive-main");
  }

  // --- MOBILE SLIDER NUDGE ---
  console.log("📱 Attempting to move mobile slider...");

  const sliderEl = document.getElementById("my-keen-slider-product");
  if (!sliderEl) {
    console.log("❌ No slider element found");
    return;
  }
  console.log("✅ Slider found:", sliderEl);

  // Only on mobile (optional)
  if (window.matchMedia && !window.matchMedia("(max-width: 768px)").matches) {
    console.log("↩️ Not mobile; skipping slide transform");
    return;
  }

  const slides = sliderEl.querySelectorAll(".keen-slider__slide");
  console.log("Slides found:", slides.length);

  // Map 1 -> 0px, 2 -> -360px, else generalize
  const offset = (i === 1) ? "0px" : (i === 2 ? "-360px" : `${-360 * (i - 1)}px`);
  console.log("Calculated offset:", offset);

  slides.forEach((slide, index) => {
    slide.style.transform = `translate3d(${offset}, 0px, 0px)`;
    console.log(`Applied transform to slide ${index}:`, slide.style.transform);
  });

  console.log("✅ Slider moved to:", offset);
}





var dzmain = {};

dzmain.Cart = (function () {
  function Cart() {
    this.name = "test";
    //props
  }

  Cart.prototype = Object.assign({}, Cart.prototype, {
    //Functions and stuff
    _init: function () {
      //console.log('init cart')
    },
  });

  return Cart;
})();

class DZCart {
  constructor() {
    this.container;
    this.itemContainer;
    this.lineItems = [];
    this.lineItemDeviders = [];
    this.count;
    this.sum;
    this.emptyText;
    this.notemptyText;
    this.subemptyText;
    this.subnotemptyText;
    this.emptyline;

    this.selectors = {
      dzCartpopup: "[data-dz-cartpopup]",
      dzCartpopupItemcontainer: "[data-dz-cartpopup-itemcontainer]",
      dzCartpopupItem: "[data-dz-cartpopup-item]",
      dzCartpopupItemDevider: "[data-dz-cartpopup-item-devider]",
      dzCartpopupCount: "[data-dz-cartpopup-count]",
      dzCartpopupSum: "[data-dz-cartpopup-sum]",
      dzCartpopupEmpty: "[data-dz-cartpopup-empty]",
      dzCartpopupNotempty: "[data-dz-cartpopup-notempty]",
      dzCartpopupSubempty: "[data-dz-cartpopup-subempty]",
      dzCartpopupSubnotempty: "[data-dz-cartpopup-subnotempty]",
      dzCartpopupEmptyline: "[data-dz-cartpopup-emptyline]",
    };
    this.init();
  }

  init() {
    this.container = document.querySelector(this.selectors.dzCartpopup);
    this.itemContainer = document.querySelector(
      this.selectors.dzCartpopupItemcontainer
    );
    this.lineItems = document.querySelectorAll(this.selectors.dzCartpopupItem);
    this.lineItemDeviders = document.querySelectorAll(
      this.selectors.dzCartpopupItemDevider
    );
    this.count = document.querySelector(this.selectors.dzCartpopupCount);
    this.sum = document.querySelector(this.selectors.dzCartpopupSum);
    this.emptyText = document.querySelector(this.selectors.dzCartpopupEmpty);
    this.notemptyText = document.querySelector(
      this.selectors.dzCartpopupNotempty
    );
    this.subemptyText = document.querySelector(
      this.selectors.dzCartpopupSubempty
    );
    this.subnotemptyText = document.querySelector(
      this.selectors.dzCartpopupSubnotempty
    );
    this.emptyline = document.querySelector(
      this.selectors.dzCartpopupEmptyline
    );
  }

  // functions
}
var popupCart = new DZCart();

class DZLogin {
  constructor() {
    this.signinBtn;
    this.emailInput;
    this.passInput;
    this.form;
    this.showPass;

    this.selectors = {
      signinBtn: "[data-dz-login-signin-btn]",
      emailInput: "#CustomerEmail",
      passInput: "#CustomerPassword",
      form: "[data-dz-login-form]",
      showPass: "[data-dz-login-showpass]",
    };
    this.init();
  }

  init() {
    this.form = document.querySelector(this.selectors.form);
    if (this.form) {
      this.signinBtn = this.form.querySelector(this.selectors.signinBtn);
      //console.log(this.signinBtn)
      this.emailInput = this.form.querySelector(this.selectors.emailInput);
      this.passInput = this.form.querySelector(this.selectors.passInput);
      this.showPass = this.form.querySelector(this.selectors.showPass);

      if (this.signinBtn) {
        //console.log('signinbutton found')
        this.signinBtn.addEventListener(
          "mouseover",
          function () {
            const cForm = this.form.querySelector("form");
            //console.log(cForm)
            if (!cForm.classList.contains("was-validated")) {
              cForm.classList.add("was-validated");
            }
          }.bind(this)
        );
      }

      if (this.showPass) {
        this.showPass.addEventListener(
          "click",
          function () {
            //console.log(this.showPass)
            if (this.passInput.type == "password") {
              this.passInput.type = "text";
            } else {
              this.passInput.type = "password";
            }
          }.bind(this)
        );
      }
    }
  }
}

var dzLogin = new DZLogin();

class DZModalLogin {
  constructor() {
    this.signinBtn;
    this.emailInput;
    this.passInput;
    this.form;
    this.showPass;

    this.selectors = {
      signinBtn: "[data-dz-login-signin-btn]",
      emailInput: "#CustomerEmail",
      passInput: "#CustomerPassword",
      form: "[data-dz-login-modalform]",
      showPass: "[data-dz-login-showpass]",
    };
    this.init();
  }

  init() {
    this.form = document.querySelector(this.selectors.form);
    if (this.form) {
      this.signinBtn = this.form.querySelector(this.selectors.signinBtn);
      // console.log(this.signinBtn)
      this.emailInput = this.form.querySelector(this.selectors.emailInput);
      this.passInput = this.form.querySelector(this.selectors.passInput);
      this.showPass = this.form.querySelector(this.selectors.showPass);

      if (this.signinBtn) {
        // console.log('signinbutton found')
        this.signinBtn.addEventListener(
          "mouseover",
          function () {
            const cForm = this.form.querySelector("form");
            // console.log(cForm)
            if (!cForm.classList.contains("was-validated")) {
              cForm.classList.add("was-validated");
            }
          }.bind(this)
        );
      }

      if (this.showPass) {
        this.showPass.addEventListener(
          "click",
          function () {
            //console.log(this.showPass)
            if (this.passInput.type == "password") {
              this.passInput.type = "text";
            } else {
              this.passInput.type = "password";
            }
          }.bind(this)
        );
      }
    }
  }
}

var dzModalLogin = new DZModalLogin();

// 39419966029982
/**
 * get cart
 * await CartHelper.getCart()
 *
 * add product
 * await CartHelper.addToCart(39419966029982, 1)
 *
 * add too much qty to Cart
 * await CartHelper.addToCart(39419966029982, 4)
 *
 * add wrong product to cart
 * await CartHelper.addToCart(1234, 1)
 */
class CartHelper {
  static async getCart() {
    return await jQuery.get(
      "/cart.js",
      function (res) {
        return res;
      },
      "json"
    );
  }

  static async addProperty(e) {
    var presentNote = "-";
    if (e.target.checked) {
      presentNote = "present";
    }
    await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        note: presentNote,
      }),
    });
  }
  static async addTreeToCart(e, id, qty, curr, properties = {}) {
    console.log("1");
    const cCart = await CartHelper.getCart();

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            quantity: qty,
            id: id,
            properties: properties,
          },
        ],
      }),
    });
    if (response.ok) {
      const itemResponse = await response.json();
      const newCart = await CartHelper.getCart();
      //console.log(cCart)

      if (cCart.items.length == 0) {
        popupCart.emptyText.classList.add("d-none");
        popupCart.notemptyText.classList.remove("d-none");
        popupCart.subemptyText.classList.add("d-none");
        popupCart.subnotemptyText.classList.remove("d-none");
        popupCart.emptyline.classList.add("d-none");
      }

      if (cCart.items.find((item) => item.id == id) == null) {
        popupCart.itemContainer.appendChild(
          TemplateHelper.createCartPopupListitem(itemResponse.items[0], curr)
        );
        popupCart.itemContainer.appendChild(
          TemplateHelper.createCartPopupDevider(itemResponse.items[0])
        );
        // popupCart.init()
      } else {
      }

      popupCart.count.innerText = newCart.items.length;
      popupCart.sum.innerText = DZCurrencyHelper.parseMoney(
        newCart.total_price / 100,
        curr
      );

      popupCart.init();

      const popupcontainer = document.querySelector(
        `[data-target=${"dz-cart-selector"}]`
      );
      if (!popupcontainer.classList.contains("show")) {
        popupcontainer.classList.add("show");
      }
    } else {
      switch (response.status) {
        case 404:
          console.log("not found");
          return null;
          break;
        case 422:
          console.log("not enough on stock");
          return null;
          break;
        default:
          console.log("unknown error", response.status);
          return null;
          break;
      }
    }
  }

static async addToCart(e, id, qty, curr, properties = {}, overstock = false) {
  console.log("cart 3");

  const selectedQtyEl = e?.target?.querySelector?.("[data-dz-qty-selector]");
  const selectedQty = selectedQtyEl ? Number(selectedQtyEl.value || 1) : 1;

  if (selectedQty > qty && overstock == false) {
    console.log("not enough in stock");
    return;
  }

  const selectedBtn = e.target.querySelector('button[type="submit"]');
  const selectedBtn_loader = selectedBtn?.querySelectorAll("[data-loader]") || [];
  const selectedBtn_text = selectedBtn?.querySelectorAll("[data-add-to-cart-text]") || [];

  if (selectedBtn_loader.length) {
    selectedBtn_loader[0].classList.remove("hide");
    selectedBtn_text[0]?.classList.add("hide");
  }

  // --------------------------------------------------
  // ✅ Detect .shop domain
  // --------------------------------------------------
  const host = (window.location.hostname || "").toLowerCase();
  const isShop =
    host === "olivetreepeople.shop" ||
    host.endsWith(".olivetreepeople.shop") ||
    host === "testolive.shop" ||
    host.endsWith(".testolive.shop");

  // --------------------------------------------------
  // ✅ On .shop → POST to US + return_to via ACTION querystring (reliable)
  // --------------------------------------------------
  if (isShop) {
    e.preventDefault();

    const BASE = "https://us.olivetreepeople.com";

    // referral: prefer ?referral=, else subdomain (lom.olivetreepeople.shop -> lom)
    const currUrl = new URL(window.location.href);
    const qp = currUrl.searchParams;

    let referral = qp.get("referral") || "";
    if (!referral) {
      const zone = "olivetreepeople.shop";
      if (host.endsWith("." + zone) && host !== zone && host !== "www." + zone) {
        referral = host.slice(0, -(zone.length + 1)).split(".")[0] || "";
      }
    }

    // Strip fbclid
    if (qp.has("fbclid")) qp.delete("fbclid");

    // --- apply your Worker rule #1 for /cart/<digits>
    const cartMatch = currUrl.pathname.match(/^\/cart\/(\d+)(?:\/)?$/);

    let returnToUrl;
    if (cartMatch) {
      // /cart/29142479 -> /pages/recommendations?plan_id=29142479 (&referral=lom)
      returnToUrl = new URL(BASE + "/pages/recommendations");
      returnToUrl.searchParams.set("plan_id", cartMatch[1]);
      if (referral) returnToUrl.searchParams.set("referral", referral);

      // carry through existing query params (except ones already set)
      qp.forEach((v, k) => {
        if (!returnToUrl.searchParams.has(k)) returnToUrl.searchParams.set(k, v);
      });
    } else {
      // keep path + query, ensure referral is present
      returnToUrl = new URL(BASE);
      returnToUrl.pathname = currUrl.pathname;

      qp.forEach((v, k) => returnToUrl.searchParams.set(k, v));
      if (referral) returnToUrl.searchParams.set("referral", referral);
    }

    // ✅ Shopify prefers a RELATIVE return_to, and it’s most reliable on the ACTION query string
    const returnToPath = returnToUrl.pathname + (returnToUrl.search ? returnToUrl.search : "");

    // Build POST form to Shopify cart/add (cross-origin allowed as form submit)
    const form = document.createElement("form");
    form.method = "POST";
    form.action = BASE + "/cart/add?return_to=" + encodeURIComponent(returnToPath);
    form.style.display = "none";

    const idInput = document.createElement("input");
    idInput.name = "id";
    idInput.value = String(id);
    form.appendChild(idInput);

    const qtyInput = document.createElement("input");
    qtyInput.name = "quantity";
    qtyInput.value = String(selectedQty);
    form.appendChild(qtyInput);

    // Line item properties
    if (properties && typeof properties === "object") {
      Object.entries(properties).forEach(([k, v]) => {
        const p = document.createElement("input");
        p.name = `properties[${k}]`;
        p.value = String(v);
        form.appendChild(p);
      });
    }

    document.body.appendChild(form);
    form.submit();
    return;
  }

  // --------------------------------------------------
  // ✅ Normal AJAX flow (non .shop) — unchanged
  // --------------------------------------------------

  const cCart = await CartHelper.getCart();

  if (
    cCart.items.length > 0 &&
    (id == 42059692835011 || id == getGiftVariantId())
  ) {
    if (cCart.items.find((item) => item.properties)) {
      if (
        cCart.items.find((item) => item.properties.brain_product == true) &&
        (cCart.items.find((item) => item.id == 42059692835011) ||
          cCart.items.find((item) => item.id == getGiftVariantId()))
      ) {
        return;
      }
    }
  }

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [{ quantity: selectedQty, id, properties }],
    }),
  });

  if (!response.ok) {
    console.log("Add to cart failed:", response.status);
    return;
  }

  const itemResponse = await response.json();
  const newCart = await CartHelper.getCart();

  if (cCart.items.length == 0) {
    popupCart.emptyText.classList.add("d-none");
    popupCart.notemptyText.classList.remove("d-none");
    popupCart.subemptyText.classList.add("d-none");
    popupCart.subnotemptyText.classList.remove("d-none");
    popupCart.emptyline.classList.add("d-none");
  }

  if (!cCart.items.find((item) => item.id == id)) {
    popupCart.itemContainer.appendChild(
      TemplateHelper.createCartPopupListitem(itemResponse.items[0], curr)
    );
    popupCart.itemContainer.appendChild(
      TemplateHelper.createCartPopupDevider(itemResponse.items[0])
    );
  }

  popupCart.count.innerText = newCart.items.length;
  popupCart.sum.innerText = DZCurrencyHelper.parseMoney(
    newCart.total_price / 100,
    curr
  );

  popupCart.init();

  const popupcontainer = document.querySelector(`[data-target="dz-cart-selector"]`);
  popupcontainer?.classList.add("show");

  if (selectedBtn_loader.length) {
    selectedBtn_loader[0].classList.add("hide");
    selectedBtn_text[0]?.classList.remove("hide");
  }
}




  
  static async autoAddToCart(
    id,
    qty,
    curr,
    properties = {},
    overstock = false
  ) {
    console.log("3");
    const cCart = await CartHelper.getCart();
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            quantity: qty,
            id: id,
            properties: properties,
          },
        ],
      }),
    });
    if (response.ok) {
      console.log(response);

      const itemResponse = await response.json();
      const newCart = await CartHelper.getCart();

      if (cCart.items.length == 0) {
        popupCart.emptyText.classList.add("d-none");
        popupCart.notemptyText.classList.remove("d-none");
        popupCart.subemptyText.classList.add("d-none");
        popupCart.subnotemptyText.classList.remove("d-none");
        popupCart.emptyline.classList.add("d-none");
      }

      if (cCart.items.find((item) => item.id == id) == null) {
        popupCart.itemContainer.appendChild(
          TemplateHelper.createCartPopupListitem(itemResponse.items[0], curr)
        );
        popupCart.itemContainer.appendChild(
          TemplateHelper.createCartPopupDevider(itemResponse.items[0])
        );
      } else {
      }

      popupCart.count.innerText = newCart.items.length;
      popupCart.sum.innerText = DZCurrencyHelper.parseMoney(
        newCart.total_price / 100,
        curr
      );

      popupCart.init();

      const popupcontainer = document.querySelector(
        `[data-target=${"dz-cart-selector"}]`
      );
      if (!popupcontainer.classList.contains("show")) {
        popupcontainer.classList.add("show");
      }
    } else {
      switch (response.status) {
        case 404:
          console.log("not found");
          return null;
          break;
        case 422:
          console.log("not enough on stock");
          return null;
          break;
        default:
          console.log("unknown error", response.status);
          return null;
          break;
      }
    }
  }

  static async addToMultiItemsCart(e, curr, ids = {}, gift_id = 0) {
    const selectedBtn = $(e.target)
      .parents(".action-buttons")
      .find("[data-multi-products-addtocart]");
    const selectedBtn_loader = selectedBtn.find("[data-loader]");
    const selectedBtn_text = selectedBtn.find("[data-add-to-cart-text]");

    if (selectedBtn_loader.length > 0) {
      selectedBtn_loader[0].classList.remove("hide");
      selectedBtn_text[0].classList.add("hide");
    }

    const cCart = await CartHelper.getCart();

    if (cCart.items.length > 0) {
      // Check for existing specific items in cart
      if (cCart.items.find((item) => item.id == 42059692835011)) {
        await this.removeFromCart(e, 42059692835011, curr);
        console.log("Removing F09 Product");
      }
      if (cCart.items.find((item) => item.id == getGiftVariantId())) {
        await this.removeFromCart(e, getGiftVariantId(), curr);
        console.log("Removing F64 Product");
      }
    }

    const addToCartItems = [];
    for (var i = 0; i < ids.length; i++) {
      addToCartItems.push({
        quantity: 1,
        id: ids[i],
        properties: {
          brain_product: true,
          brain_gift_id: gift_id,
        },
      });
    }

    console.log(addToCartItems);
    console.log("4");
    // Add items one by one to handle out-of-stock cases
    for (let item of addToCartItems) {
      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: [item] }), // Add one item at a time
        });

        if (response.ok) {
          const itemResponse = await response.json();
          const newCart = await CartHelper.getCart();

          // Update cart popup UI
          if (cCart.items.length == 0) {
            popupCart.emptyText.classList.add("d-none");
            popupCart.notemptyText.classList.remove("d-none");
            popupCart.subemptyText.classList.add("d-none");
            popupCart.subnotemptyText.classList.remove("d-none");
            popupCart.emptyline.classList.add("d-none");
          }

          // Add new item to cart popup if not already present
          if (
            itemResponse.items.length > 0 &&
            !cCart.items.find((cartItem) => cartItem.id == item.id)
          ) {
            popupCart.itemContainer.appendChild(
              TemplateHelper.createCartPopupListitem(
                itemResponse.items[0],
                curr
              )
            );
            popupCart.itemContainer.appendChild(
              TemplateHelper.createCartPopupDevider(itemResponse.items[0])
            );
          }

          // Update cart count and total
          popupCart.count.innerText = newCart.items.length;
          popupCart.sum.innerText = DZCurrencyHelper.parseMoney(
            newCart.total_price / 100,
            curr
          );
          popupCart.init();

          const popupcontainer = document.querySelector(
            `[data-target=${"dz-cart-selector"}]`
          );
          if (!popupcontainer.classList.contains("show")) {
            popupcontainer.classList.add("show");
          }
        } else {
          switch (response.status) {
            case 422:
              console.log(`Item ${item.id} not enough in stock.`);
              break;
            default:
              console.log(
                `Unknown error for item ${item.id}:`,
                response.status
              );
              break;
          }
        }
      } catch (error) {
        console.log(`Error adding item ${item.id} to cart:`, error);
      }
    }

    // Restore button text/loader
    if (selectedBtn_loader.length > 0) {
      selectedBtn_loader[0].classList.add("hide");
      selectedBtn_text[0].classList.remove("hide");
    }
  }

  static async addToMultiItemsCartCustomCart(e, curr, ids = [], gift_id = 0) {
  const selectedBtn = $(e.target)
    .parents(".action-buttons")
    .find("[data-multi-products-addtocart]");
  const selectedBtn_loader = selectedBtn.find("[data-loader]");
  const selectedBtn_text = selectedBtn.find("[data-add-to-cart-text]");

  if (selectedBtn_loader.length > 0) {
    selectedBtn_loader[0].classList.remove("hide");
    selectedBtn_text[0].classList.add("hide");
  }

  // --------------------------------------------------
  // ✅ Detect .shop domain
  // --------------------------------------------------
  const host = (window.location.hostname || "").toLowerCase();
  const isShop =
     host === "olivetreepeople.shop" ||
    host.endsWith(".olivetreepeople.shop") ||
    host === "testolive.shop" ||
    host.endsWith(".testolive.shop");

    
  // --------------------------------------------------
  // ✅ On .shop → POST to US via FORM (no CORS) + return_to via querystring
  // --------------------------------------------------
  if (isShop) {
    e.preventDefault?.();

    const BASE = "https://us.olivetreepeople.com";

    // referral: prefer ?referral=, else subdomain (lom.olivetreepeople.shop -> lom)
    const currUrl = new URL(window.location.href);
    const qp = currUrl.searchParams;

    let referral = qp.get("referral") || "";
    if (!referral) {
      const zone = "olivetreepeople.shop";
      if (host.endsWith("." + zone) && host !== zone && host !== "www." + zone) {
        referral = host.slice(0, -(zone.length + 1)).split(".")[0] || "";
      }
    }

    // Strip fbclid
    if (qp.has("fbclid")) qp.delete("fbclid");

    // Worker rule #1 for /cart/<digits> -> /pages/recommendations?plan_id=...
    const cartMatch = currUrl.pathname.match(/^\/cart\/(\d+)(?:\/)?$/);

    let returnToUrl;
    if (cartMatch) {
      returnToUrl = new URL(BASE + "/pages/recommendations");
      returnToUrl.searchParams.set("plan_id", cartMatch[1]);
      if (referral) returnToUrl.searchParams.set("referral", referral);

      // carry existing query params (except ones already set)
      qp.forEach((v, k) => {
        if (!returnToUrl.searchParams.has(k)) returnToUrl.searchParams.set(k, v);
      });
    } else {
      returnToUrl = new URL(BASE);
      returnToUrl.pathname = currUrl.pathname;
      qp.forEach((v, k) => returnToUrl.searchParams.set(k, v));
      if (referral) returnToUrl.searchParams.set("referral", referral);
    }

    // Shopify is most reliable with a RELATIVE return_to in the action querystring
    const returnToPath = returnToUrl.pathname + (returnToUrl.search ? returnToUrl.search : "");

    // Build a single form that posts multiple line items:
    // items[0][id], items[0][quantity], items[0][properties][custom_cart], ...
    const form = document.createElement("form");
    form.method = "POST";
    form.action = BASE + "/cart/add?return_to=" + encodeURIComponent(returnToPath);
    form.style.display = "none";

    // Build items
    const safeIds = Array.isArray(ids) ? ids : [];
    for (let i = 0; i < safeIds.length; i++) {
      const vid = safeIds[i];
      if (!vid) continue;

      const idInput = document.createElement("input");
      idInput.name = `items[${i}][id]`;
      idInput.value = String(vid);
      form.appendChild(idInput);

      const qtyInput = document.createElement("input");
      qtyInput.name = `items[${i}][quantity]`;
      qtyInput.value = "1";
      form.appendChild(qtyInput);

      // properties[custom_cart]=true
      const propInput = document.createElement("input");
      propInput.name = `items[${i}][properties][custom_cart]`;
      propInput.value = "true";
      form.appendChild(propInput);

      // OPTIONAL: if you want gift_id or other properties, add here
      // if (gift_id) { ... }
    }

    document.body.appendChild(form);
    form.submit();
    return; // stop here — navigates to us.olivetreepeople.com
  }

  // --------------------------------------------------
  // ✅ Normal AJAX flow (non .shop) — unchanged
  // --------------------------------------------------

  const cCart = await CartHelper.getCart();

  if (cCart.items.length > 0) {
    if (cCart.items.find((item) => item.id == 42059692835011)) {
      await this.removeFromCart(e, 42059692835011, curr);
      console.log("Removing F09 Product");
    }
    if (cCart.items.find((item) => item.id == getGiftVariantId())) {
      await this.removeFromCart(e, getGiftVariantId(), curr);
      console.log("Removing F64 Product");
    }
  }

  const addToCartItems = [];
  for (var i = 0; i < ids.length; i++) {
    addToCartItems.push({
      quantity: 1,
      id: ids[i],
      properties: { custom_cart: true },
    });
  }

  console.log(addToCartItems);

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ items: addToCartItems }),
  });

  if (response.ok) {
    const itemResponse = await response.json();
    const newCart = await CartHelper.getCart();

    if (cCart.items.length == 0) {
      popupCart.emptyText.classList.add("d-none");
      popupCart.notemptyText.classList.remove("d-none");
      popupCart.subemptyText.classList.add("d-none");
      popupCart.subnotemptyText.classList.remove("d-none");
      popupCart.emptyline.classList.add("d-none");
    }

    if (itemResponse.items.length > 0) {
      for (var j = 0; j < itemResponse.items.length; j++) {
        if (cCart.items.find((item) => item.id == ids[j]) == null) {
          popupCart.itemContainer.appendChild(
            TemplateHelper.createCartPopupListitem(itemResponse.items[j], curr)
          );
          popupCart.itemContainer.appendChild(
            TemplateHelper.createCartPopupDevider(itemResponse.items[j])
          );
        }
      }
    }

    popupCart.count.innerText = newCart.items.length;
    popupCart.sum.innerText = DZCurrencyHelper.parseMoney(
      newCart.total_price / 100,
      curr
    );
    popupCart.init();

    const popupcontainer = document.querySelector(`[data-target=${"dz-cart-selector"}]`);
    if (!popupcontainer.classList.contains("show")) {
      popupcontainer.classList.add("show");
    }

    if (selectedBtn_loader.length > 0) {
      selectedBtn_loader[0].classList.add("hide");
      selectedBtn_text[0].classList.remove("hide");
    }
  } else {
    switch (response.status) {
      case 404:
        console.log("not found");
        return null;
      case 422:
        console.log("not enough on stock");
        return null;
      default:
        console.log("unknown error", response.status);
        return null;
    }
  }

  if (selectedBtn_loader.length > 0) {
    selectedBtn_loader[0].classList.add("hide");
    selectedBtn_text[0].classList.remove("hide");
  }
}






  static async addToMultiItemsCartBundle(e, curr, ids = {}, gift_id = 0) {
    const selectedBtn = $(e.target)
      .parents(".action-buttons")
      .find("[data-multi-products-addtocart]");
    const selectedBtn_loader = selectedBtn.find("[data-loader]");
    const selectedBtn_text = selectedBtn.find("[data-add-to-cart-text]");

    if (selectedBtn_loader.length > 0) {
      selectedBtn_loader[0].classList.remove("hide");
      selectedBtn_text[0].classList.add("hide");
    }

    const cCart = await CartHelper.getCart();

    if (cCart.items.length > 0) {
      // product variant id is F09 or F64 (Regime Brain Gift Product)
      // if(cCart.items.find(item=>item.id == 42059692835011) || cCart.items.find(item=>item.id == getGiftVariantId())){
      if (cCart.items.find((item) => item.id == 42059692835011)) {
        // ids = ids.filter(function(ele){
        //     if(ele != 42059692835011 || ele != getGiftVariantId()) return ele;
        // });
        await this.removeFromCart(e, 42059692835011, curr);
        console.log("Removing F09 Product");
      }
      if (cCart.items.find((item) => item.id == getGiftVariantId())) {
        await this.removeFromCart(e, getGiftVariantId(), curr);
        console.log("Removing F64 Product");
      }
    }

    const addToCartItems = [];

    for (var i = 0; i < ids.length; i++) {
      addToCartItems.push({
        quantity: 1,
        id: ids[i],
        properties: {
          BYOB: "product",
        },
      });
    }

    console.log(addToCartItems);

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: addToCartItems,
      }),
    });

    if (response.ok) {
      const itemResponse = await response.json();
      const newCart = await CartHelper.getCart();

      if (cCart.items.length == 0) {
        popupCart.emptyText.classList.add("d-none");
        popupCart.notemptyText.classList.remove("d-none");
        popupCart.subemptyText.classList.add("d-none");
        popupCart.subnotemptyText.classList.remove("d-none");
        popupCart.emptyline.classList.add("d-none");
      }

      if (itemResponse.items.length > 0) {
        for (var j = 0; j < itemResponse.items.length; j++) {
          if (cCart.items.find((item) => item.id == ids[j]) == null) {
            popupCart.itemContainer.appendChild(
              TemplateHelper.createCartPopupListitem(
                itemResponse.items[j],
                curr
              )
            );
            popupCart.itemContainer.appendChild(
              TemplateHelper.createCartPopupDevider(itemResponse.items[j])
            );
          }
        }
      }

      popupCart.count.innerText = newCart.items.length;
      popupCart.sum.innerText = DZCurrencyHelper.parseMoney(
        newCart.total_price / 100,
        curr
      );
      popupCart.init();

      const popupcontainer = document.querySelector(
        `[data-target=${"dz-cart-selector"}]`
      );
      if (!popupcontainer.classList.contains("show")) {
        popupcontainer.classList.add("show");
      }

      if (selectedBtn_loader.length > 0) {
        selectedBtn_loader[0].classList.add("hide");
        selectedBtn_text[0].classList.remove("hide");
      }
    } else {
      switch (response.status) {
        case 404:
          console.log("not found");
          return null;
          break;
        case 422:
          console.log("not enough on stock");
          return null;
          break;
        default:
          console.log("unknown error", response.status);
          return null;
          break;
      }

      if (selectedBtn_loader.length > 0) {
        selectedBtn_loader[0].classList.add("hide");
        selectedBtn_text[0].classList.remove("hide");
      }
    }
  }




static async addToMultiItemsCartORBundle(e, curr, ids = [], gift_id = 0) {
  const selectedBtn = $(e.target)
    .parents(".action-buttons")
    .find("[data-multi-products-addtocart]");

  const selectedBtn_loader = selectedBtn.find("[data-loader]");
  const selectedBtn_text = selectedBtn.find("[data-add-to-cart-text]");

  const showLoader = () => {
    if (selectedBtn_loader.length > 0 && selectedBtn_text.length > 0) {
      selectedBtn_loader[0].classList.remove("hide");
      selectedBtn_text[0].classList.add("hide");
    }
  };

  const hideLoader = () => {
    if (selectedBtn_loader.length > 0 && selectedBtn_text.length > 0) {
      selectedBtn_loader[0].classList.add("hide");
      selectedBtn_text[0].classList.remove("hide");
    }
  };

  showLoader();

  try {
    const cCart = await CartHelper.getCart();

    if (cCart.items.length > 0) {
      if (cCart.items.find((item) => item.id == 42059692835011)) {
        await this.removeFromCart(e, 42059692835011, curr);
        console.log("Removing F09 Product");
      }

      if (typeof getGiftVariantId === "function" && cCart.items.find((item) => item.id == getGiftVariantId())) {
        await this.removeFromCart(e, getGiftVariantId(), curr);
        console.log("Removing F64 Product");
      }
    }

    const addToCartItems = [];

    for (var i = 0; i < ids.length; i++) {
      addToCartItems.push({
        quantity: 1,
        id: ids[i]
      });
    }

    console.log(addToCartItems);

    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: addToCartItems,
      }),
    });

    if (!response.ok) {
      switch (response.status) {
        case 404:
          console.log("not found");
          break;
        case 422:
          console.log("not enough on stock");
          break;
        default:
          console.log("unknown error", response.status);
          break;
      }

      hideLoader();
      return null;
    }

    const itemResponse = await response.json();

    try {
      await fetch("/discount/MYORSET");
      console.log("MYORSET discount applied");
    } catch (err) {
      console.warn("Could not apply MYORSET discount code", err);
    }

    const newCart = await CartHelper.getCart();

    if (cCart.items.length == 0) {
      popupCart.emptyText.classList.add("d-none");
      popupCart.notemptyText.classList.remove("d-none");
      popupCart.subemptyText.classList.add("d-none");
      popupCart.subnotemptyText.classList.remove("d-none");
      popupCart.emptyline.classList.add("d-none");
    }

    if (itemResponse.items.length > 0) {
      for (var j = 0; j < itemResponse.items.length; j++) {
        if (cCart.items.find((item) => item.id == ids[j]) == null) {
          popupCart.itemContainer.appendChild(
            TemplateHelper.createCartPopupListitem(
              itemResponse.items[j],
              curr
            )
          );

          popupCart.itemContainer.appendChild(
            TemplateHelper.createCartPopupDevider(itemResponse.items[j])
          );
        }
      }
    }

    popupCart.count.innerText = newCart.items.length;
    popupCart.sum.innerText = DZCurrencyHelper.parseMoney(
      newCart.total_price / 100,
      curr
    );

    popupCart.init();

    const popupcontainer = document.querySelector(
      `[data-target=${"dz-cart-selector"}]`
    );

    if (popupcontainer && !popupcontainer.classList.contains("show")) {
      popupcontainer.classList.add("show");
    }

    hideLoader();
  } catch (err) {
    console.error("addToMultiItemsCartORBundle error:", err);
    hideLoader();
    return null;
  }
}


  static async updateCart(id, type, curr) {
    console.log("cart 4");
    const cCart = await CartHelper.getCart();
    const cItem = cCart.items.find((item) => item.id == id);
    //console.log(cItem)
    if (cItem == undefined) {
      return;
    }

    if (
      cCart.items.length > 0 &&
      (id == 42059692835011 || id == getGiftVariantId())
    ) {
      // product variant id is F09 or F64 (Regime Brain Gift Product)
      if (
        cCart.items.find((item) => item.properties.brain_product == true) &&
        cCart.items.find((item) => item.id == id)
      ) {
        return;
      }
    }

    var newQty = cItem.quantity;
    //console.log(newQty)
    if (type == "add") {
      newQty++;
    } else {
      newQty--;
    }

    //Update Brain Gift Products
    var gift_cart_f09_num = 0,
      gift_cart_f06_num = 0;
    for (var i = 0; i < cCart.items.length; i++) {
      if (
        typeof cCart.items[i].properties !== "undefined" &&
        cCart.items[i].properties
      ) {
        if (typeof cCart.items[i].properties.brain_product !== "undefined") {
          if (
            cCart.items[i].properties.brain_product == true &&
            cCart.items[i].properties.brain_gift_id > 0
          ) {
            if (cCart.items[i].properties.brain_gift_id === 42059692835011)
              gift_cart_f09_num++;
            if (cCart.items[i].properties.brain_gift_id === getGiftVariantId())
              gift_cart_f06_num++;
          }
        }
      }
    }

    if (newQty === 0) {
      if (typeof cItem !== "undefined") {
        if (typeof cItem.properties !== "undefined") {
          if (cItem.properties) {
            if (typeof cItem.properties.brain_product !== "undefined") {
              if (
                cItem.properties.brain_product == true &&
                cItem.properties.brain_gift_id > 0
              ) {
                if (
                  cCart.items.find((item) => item.id === 42059692835011) &&
                  cItem.properties.brain_gift_id === 42059692835011
                ) {
                  // F09 Gift Product
                  if (gift_cart_f09_num === 3) {
                    await this.autoRemoveFromCart(42059692835011, curr);
                    await this.autoAddToCart(39806926422211, 1, curr); //Add F09 Product to the cart
                  }
                }
                if (
                  cCart.items.find((item) => item.id === getGiftVariantId()) &&
                  cItem.properties.brain_gift_id === getGiftVariantId()
                ) {
                  // F64 Gift Product
                  if (gift_cart_f06_num === 3) {
                    await this.autoRemoveFromCart(getGiftVariantId(), curr);
                    await this.autoAddToCart(39806952505539, 1, curr); //Add F64 Product to the cart
                  }
                }
              }
            }
          }
        }
      }
    }

    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: `${id}`,
        quantity: newQty,
      }),
    });
    if (response.ok) {
      const cartResponse = await response.json();
      const newItem = cartResponse.items.find((item) => item.id == id);
      if (newItem == undefined) {
        //console.log('item removed')
        if (
          Array.from(popupCart.lineItems).find(
            (item) => item.dataset.dzCartpopupItem == id
          )
        )
          Array.from(popupCart.lineItems)
            .find((item) => item.dataset.dzCartpopupItem == id)
            .remove();
        if (
          Array.from(popupCart.lineItemDeviders).find(
            (item) => item.dataset.dzCartpopupItemDevider == id
          )
        )
          Array.from(popupCart.lineItemDeviders)
            .find((item) => item.dataset.dzCartpopupItemDevider == id)
            .remove();
        popupCart.count.innerText = cartResponse.items.length;
        popupCart.sum.innerText = DZCurrencyHelper.parseMoney(
          cartResponse.total_price / 100,
          curr
        );
        if (cartResponse.items.length == 0) {
          popupCart.emptyText.classList.remove("d-none");
          popupCart.notemptyText.classList.add("d-none");
          popupCart.subemptyText.classList.remove("d-none");
          popupCart.subnotemptyText.classList.add("d-none");
          popupCart.emptyline.classList.remove("d-none");
        }
      } else {
        if (newItem.quantity == cItem.quantity) {
          //console.log('not enough in stock')
        } else {
          //console.log('changed qty')
          if (
            Array.from(popupCart.lineItems).find(
              (item) => item.dataset.dzCartpopupItem == id
            )
          ) {
            var cItemQty = Array.from(popupCart.lineItems)
              .find((item) => item.dataset.dzCartpopupItem == id)
              .querySelector("[data-dz-cartpopup-item-qty]");
            cItemQty.innerText = newQty;
          }
          popupCart.count.innerText = cartResponse.items.length;
          popupCart.sum.innerText = DZCurrencyHelper.parseMoney(
            cartResponse.total_price / 100,
            curr
          );
        }
       }

      if (typeof forceRefreshCartPopup === "function") {
        await forceRefreshCartPopup();
      }
      
      return cartResponse;
    } else {
      switch (response.status) {
        case 404:
          console.log("not found", await response.json());
          return null;
          break;
        case 422:
          console.log("not enough on stock", await response.json());
          return null;
          break;
        case 400:
          console.log("bad request", await response.json());
          return null;
          break;
        default:
          console.log("unknown error", response.status, await response.json());
          return null;
          break;
      }
    }
  }

  static async autoUpdateCart(id, qty, curr) {
    const cCart = await CartHelper.getCart();
    const cItem = cCart.items.find((item) => item.id == id);
    //console.log(cItem)
    if (cItem == undefined) {
      return;
    }

    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: `${id}`,
        quantity: qty,
      }),
    });
    if (response.ok) {
      const cartResponse = await response.json();
      const newItem = cartResponse.items.find((item) => item.id == id);
      if (newItem == undefined) {
        if (
          Array.from(popupCart.lineItems).find(
            (item) => item.dataset.dzCartpopupItem == id
          )
        )
          Array.from(popupCart.lineItems)
            .find((item) => item.dataset.dzCartpopupItem == id)
            .remove();
        if (
          Array.from(popupCart.lineItemDeviders).find(
            (item) => item.dataset.dzCartpopupItemDevider == id
          )
        )
          Array.from(popupCart.lineItemDeviders)
            .find((item) => item.dataset.dzCartpopupItemDevider == id)
            .remove();
        popupCart.count.innerText = cartResponse.items.length;
        popupCart.sum.innerText = DZCurrencyHelper.parseMoney(
          cartResponse.total_price / 100,
          curr
        );
        if (cartResponse.items.length == 0) {
          popupCart.emptyText.classList.remove("d-none");
          popupCart.notemptyText.classList.add("d-none");
          popupCart.subemptyText.classList.remove("d-none");
          popupCart.subnotemptyText.classList.add("d-none");
          popupCart.emptyline.classList.remove("d-none");
        }
      } else {
        if (newItem.quantity == cItem.quantity) {
          //console.log('not enough in stock')
        } else {
          //console.log('changed qty')
          if (
            Array.from(popupCart.lineItems).find(
              (item) => item.dataset.dzCartpopupItem == id
            )
          ) {
            var cItemQty = Array.from(popupCart.lineItems)
              .find((item) => item.dataset.dzCartpopupItem == id)
              .querySelector("[data-dz-cartpopup-item-qty]");
            cItemQty.innerText = qty;
          }
          popupCart.count.innerText = cartResponse.items.length;
          popupCart.sum.innerText = DZCurrencyHelper.parseMoney(
            cartResponse.total_price / 100,
            curr
          );
        }
      }
      return cartResponse;
    } else {
      switch (response.status) {
        case 404:
          console.log("not found", await response.json());
          return null;
          break;
        case 422:
          console.log("not enough on stock", await response.json());
          return null;
          break;
        case 400:
          console.log("bad request", await response.json());
          return null;
          break;
        default:
          console.log("unknown error", response.status, await response.json());
          return null;
          break;
      }
    }
  }

  static async removeFromCart(e, id, curr) {
    e.preventDefault();
    const cCart = await CartHelper.getCart();
    const cItem = cCart.items.find((item) => item.id == id);
    if (cItem == undefined) {
      return null;
    }
    console.log(cCart.items);

    var gift_cart_f09_num = 0,
      gift_cart_f06_num = 0;
    for (var i = 0; i < cCart.items.length; i++) {
      if (
        typeof cCart.items[i].properties !== "undefined" &&
        cCart.items[i].properties
      ) {
        if (typeof cCart.items[i].properties.brain_product !== "undefined") {
          if (
            cCart.items[i].properties.brain_product == true &&
            cCart.items[i].properties.brain_gift_id > 0
          ) {
            if (cCart.items[i].properties.brain_gift_id === 42059692835011)
              gift_cart_f09_num++;
            if (cCart.items[i].properties.brain_gift_id === getGiftVariantId())
              gift_cart_f06_num++;
          }
        }
      }
    }

    if (typeof cItem !== "undefined") {
      if (typeof cItem.properties !== "undefined") {
        if (cItem.properties) {
          if (typeof cItem.properties.brain_product !== "undefined") {
            if (
              cItem.properties.brain_product == true &&
              cItem.properties.brain_gift_id > 0
            ) {
              if (
                cCart.items.find((item) => item.id === 42059692835011) &&
                cItem.properties.brain_gift_id === 42059692835011
              ) {
                // F09 Gift Product

                if (gift_cart_f09_num === 3) {
                  await this.autoRemoveFromCart(42059692835011, curr);
                  await this.autoAddToCart(39806926422211, 1, curr); //Add F09 Product to the cart
                }
              }
              if (
                cCart.items.find((item) => item.id === getGiftVariantId()) &&
                cItem.properties.brain_gift_id === getGiftVariantId()
              ) {
                // F64 Gift Product
                if (gift_cart_f06_num === 3) {
                  await this.autoRemoveFromCart(getGiftVariantId(), curr);
                  await this.autoAddToCart(39806952505539, 1, curr); //Add F64 Product to the cart
                }
              }
            }
          }
        }
      }
    }

    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: `${id}`,
        quantity: 0,
      }),
    });
    if (response.ok) {
      const cartResponse = await response.json();
      const newItem = cartResponse.items.find((item) => item.id == id);
      if (newItem == undefined) {
        //console.log('item removed',cartResponse)

        if (
          Array.from(popupCart.lineItems).find(
            (item) => item.dataset.dzCartpopupItem == id
          )
        )
          Array.from(popupCart.lineItems)
            .find((item) => item.dataset.dzCartpopupItem == id)
            .remove();
        if (
          Array.from(popupCart.lineItemDeviders).find(
            (item) => item.dataset.dzCartpopupItemDevider == id
          )
        )
          Array.from(popupCart.lineItemDeviders)
            .find((item) => item.dataset.dzCartpopupItemDevider == id)
            .remove();

        popupCart.count.innerText = cartResponse.items.length;
        popupCart.sum.innerText = DZCurrencyHelper.parseMoney(
          cartResponse.total_price / 100,
          curr
        );

        if (cartResponse.items.length == 0) {
          popupCart.emptyText.classList.remove("d-none");
          popupCart.notemptyText.classList.add("d-none");
          popupCart.subemptyText.classList.remove("d-none");
          popupCart.subnotemptyText.classList.add("d-none");
          popupCart.emptyline.classList.remove("d-none");
        }
      } else {
        console.log("something went wrong, item not removed");
      }

      if (typeof forceRefreshCartPopup === "function") {
        await forceRefreshCartPopup();
      }

      return cartResponse;
    } else {
      switch (response.status) {
        case 404:
          console.log("not found", await response.json());
          return null;
          break;
        case 422:
          console.log("not enough on stock", await response.json());
          return null;
          break;
        case 400:
          console.log("bad request", await response.json());
          return null;
          break;
        default:
          console.log("unknown error", response.status, await response.json());
          return null;
          break;
      }
    }
  }




  static async autoRemoveFromCart(id, curr) {
    const cCart = await CartHelper.getCart();
    const cItem = cCart.items.find((item) => item.id == id);

    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: `${id}`,
        quantity: 0,
      }),
    });
    if (response.ok) {
      console.log(response);

      const cartResponse = await response.json();
      const newItem = cartResponse.items.find((item) => item.id == id);
      if (newItem == undefined) {
        if (
          Array.from(popupCart.lineItems).find(
            (item) => item.dataset.dzCartpopupItem == id
          )
        )
          Array.from(popupCart.lineItems)
            .find((item) => item.dataset.dzCartpopupItem == id)
            .remove();
        if (
          Array.from(popupCart.lineItemDeviders).find(
            (item) => item.dataset.dzCartpopupItemDevider == id
          )
        )
          Array.from(popupCart.lineItemDeviders)
            .find((item) => item.dataset.dzCartpopupItemDevider == id)
            .remove();

        popupCart.count.innerText = cartResponse.items.length;
        popupCart.sum.innerText = DZCurrencyHelper.parseMoney(
          cartResponse.total_price / 100,
          curr
        );

        if (cartResponse.items.length == 0) {
          popupCart.emptyText.classList.remove("d-none");
          popupCart.notemptyText.classList.add("d-none");
          popupCart.subemptyText.classList.remove("d-none");
          popupCart.subnotemptyText.classList.add("d-none");
          popupCart.emptyline.classList.remove("d-none");
        }
      } else {
        console.log("something went wrong, item not removed");
      }
      return cartResponse;
    } else {
      switch (response.status) {
        case 404:
          console.log("not found", await response.json());
          return null;
          break;
        case 422:
          console.log("not enough on stock", await response.json());
          return null;
          break;
        case 400:
          console.log("bad request", await response.json());
          return null;
          break;
        default:
          console.log("unknown error", response.status, await response.json());
          return null;
          break;
      }
    }
  }

  static async manualRemoveFromCartReload(e, id, curr) {
    e.preventDefault();
    const cCart = await CartHelper.getCart();

    console.log(cCart);

    var cItem = cCart.items.find((item) => item.id == id);

    var gift_cart_f09_num = 0,
      gift_cart_f06_num = 0;
    for (var i = 0; i < cCart.items.length; i++) {
      if (
        typeof cCart.items[i].properties !== "undefined" &&
        cCart.items[i].properties
      ) {
        if (typeof cCart.items[i].properties.brain_product !== "undefined") {
          if (
            cCart.items[i].properties.brain_product == true &&
            cCart.items[i].properties.brain_gift_id > 0
          ) {
            if (cCart.items[i].properties.brain_gift_id === 42059692835011)
              gift_cart_f09_num++;
            if (cCart.items[i].properties.brain_gift_id === getGiftVariantId())
              gift_cart_f06_num++;
          }
        }
      }
    }

    if (typeof cItem !== "undefined") {
      if (typeof cItem.properties !== "undefined") {
        if (cItem.properties) {
          if (typeof cItem.properties.brain_product !== "undefined") {
            if (
              cItem.properties.brain_product == true &&
              cItem.properties.brain_gift_id > 0
            ) {
              if (
                cCart.items.find((item) => item.id === 42059692835011) &&
                cItem.properties.brain_gift_id === 42059692835011
              ) {
                // F09 Gift Product
                if (gift_cart_f09_num === 3) {
                  await CartHelper.autoRemoveFromCart(42059692835011, curr);
                  await CartHelper.autoAddToCart(39806926422211, 1, curr); //Add F09 Product to the cart
                }
              }
              if (
                cCart.items.find((item) => item.id === getGiftVariantId()) &&
                cItem.properties.brain_gift_id === getGiftVariantId()
              ) {
                // F64 Gift Product
                if (gift_cart_f06_num === 3) {
                  await CartHelper.autoRemoveFromCart(getGiftVariantId(), curr);
                  await CartHelper.autoAddToCart(39806952505539, 1, curr); //Add F64 Product to the cart
                }
              }
            }
          }
        }
      }
    }
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: `${id}`,
        quantity: 0,
      }),
    });
    if (response.ok) {
      console.log(response);
      location.reload();
    } else {
      switch (response.status) {
        case 404:
          console.log("not found", await response.json());
          return null;
          break;
        case 422:
          console.log("not enough on stock", await response.json());
          return null;
          break;
        case 400:
          console.log("bad request", await response.json());
          return null;
          break;
        default:
          console.log("unknown error", response.status, await response.json());
          return null;
          break;
      }
    }
  }
}

class TemplateHelper {
  static createCartPopupListitem(item, curr) {
    var node = document.createElement("li");
    node.dataset.dzCartpopupItem = item.id;
    node.classList.add("pt-3");
    node.classList.add("px-4");

    console.log("DEBUG INITIAL ITEM FROM ADD RESPONSE", {
      id: item.id,
      line_price: item.line_price,
      final_price: item.final_price,
      final_line_price: item.final_line_price,
      rendered_price: DZCurrencyHelper.parseMoney(item.line_price / 100, curr),
      item: item,
    });

    var cartitemVariant = item.variant_title;
    if (item.variant_title == null && item.unit_price_measurement) {
      cartitemVariant =
        item.unit_price_measurement.quantity_value.split(".")[0] +
        " " +
        item.unit_price_measurement.quantity_unit;
    } else if (item.variant_title == null && !item.unit_price_measurement) {
      cartitemVariant = "-";
    }

    var node_innerHTML = `<div class="d-flex justify-content-between dz-cart-dropdown-item-inner">
            <div class="d-flex">
                <div class="pe-3 d-flex align-items-end" style="min-width:80px;max-width:80px;">
                    <img data-cart-item-image class="" src="${item.image}"  data-cart-item-image alt="item.variant_title">
    
                </div>
                <div class="d-flex flex-column flex-wrap">
                    <div>
                        <span class="dz-cartitem-vendor m-0 fs-13 fs-xs-10">${item.vendor}</span>
                        <p data-cart-item-title data-role="product-title" class="dz-cartitem-title fw-900">${item.product_title}</p>
                
                        <p class="dz-cartitem-variant">${cartitemVariant}</p>
                    </div>
                    <div>`;

    if (item.id == 42059692835011 || item.id == getGiftVariantId()) {
      node_innerHTML += `<div class="">
                          <p class="dz-cartitem-variant">${theme.dzStrings.count}: <span data-dz-cartpopup-item-qty>${item.quantity}</span></p>
                        </div>`;
    } else {
      node_innerHTML += `<div class="">
                          <p class="dz-cartitem-variant">${theme.dzStrings.count}: <span class="dz-pointer mx-2" onclick="CartHelper.updateCart(${item.id},'remove', '${curr}')">-</span><span data-dz-cartpopup-item-qty>${item.quantity}</span><span class="dz-pointer mx-2" onclick="CartHelper.updateCart(${item.id},'add', '${curr}')">+</span></p>
                        </div>`;
    }

    node_innerHTML += `  <a href="" style="color:#595959!important;" class="dz-no-text-deco fs-12" onclick="CartHelper.removeFromCart(event,${
      item.id
    }, '${curr}')">
                      
                        ${theme.dzStrings.delete}
                      
                      </a>
                    
                  </div>
                    
                </div>
    
            </div>
            
            <div class="text-end">
                <span class="fs-14 fw-900 text-nowrap mt-4 d-block" data-cart-live-price id="js 1">&nbsp;<br>${DZCurrencyHelper.parseMoney(
                  item.line_price / 100,
                  curr
                )}</span>
            </div>
        </div>`;

    node.innerHTML = node_innerHTML;

    console.log("DEBUG INITIAL DOM PRICE", {
      id: item.id,
      dom_price: node.querySelector("[data-cart-live-price]")?.innerText,
    });

setTimeout(function () {
  console.log("DEBUG FETCHING DELAYED LIVE CART FOR ALL ITEMS");

  fetch("/cart.js", { cache: "no-store" })
    .then((res) => res.json())
    .then((cart) => {

      cart.items.forEach((liveItem) => {

        var itemEl = document.querySelector(
          `[data-dz-cartpopup-item="${liveItem.id}"]`
        );

        if (!itemEl) {
          console.log("DEBUG ITEM ELEMENT NOT FOUND", {
            id: liveItem.id,
            liveItem: liveItem,
          });
          return;
        }

        var priceEl = itemEl.querySelector("[data-cart-live-price]");

        if (!priceEl) {
          console.log("DEBUG PRICE ELEMENT NOT FOUND", {
            id: liveItem.id,
            itemEl: itemEl,
          });
          return;
        }

        var liveRenderedPrice = DZCurrencyHelper.parseMoney(
          liveItem.line_price / 100,
          curr
        );

        priceEl.innerHTML = "&nbsp;<br>" + liveRenderedPrice;

        console.log("DEBUG UPDATED POPUP ITEM PRICE", {
          id: liveItem.id,
          title: liveItem.product_title,
          line_price: liveItem.line_price,
          final_price: liveItem.final_price,
          final_line_price: liveItem.final_line_price,
          rendered_price: liveRenderedPrice,
          dom_price: priceEl.innerText,
        });

      });

      console.log("DEBUG FINISHED UPDATING ALL POPUP PRICES", {
        cart_total: cart.total_price,
        item_count: cart.item_count,
      });

    })
    .catch((err) => {
      console.log("DEBUG LIVE CART FETCH ERROR", err);
    });
}, 800);

    return node;
  }

  static createCartPopupDevider(item) {
    var node = document.createElement("div");
    node.dataset.dzCartpopupItemDevider = item.id;

    node.classList.add("dz-dotted-line-wrapper");
    node.classList.add("mt-3");
    node.innerHTML = '<span class="dz-dotted-img m-0"></span>';

    return node;
  }
}

class DZProduct {
  constructor(cProduct, cVariant, item) {
    this.title = cProduct.title;
    this.vendor = cProduct.vendor;
    this.available = cProduct.available;
    this.featured_image = cProduct.featured_image;
    this.url = cProduct.url;
    this.options = cProduct.options;

    this.price = cVariant.price;
    this.compare_at_price = cVariant.compare_at_price;
    this.final_price = item.final_price;
    this.sku = cVariant.sku;

    this.quantity = item.quantity;
  }
}

class DZCartDetails {
  constructor() {
    this.cart_level_discounts;
    this.items = [];
  }

  async getCart() {
    const cCart = await CartHelper.getCart();

    this.item_count = cCart.item_count;
    this.line_count = cCart.items.length;
    this.note = cCart.note;
    this.items_subtotal_price = cCart.items_subtotal_price;
    this.original_total_price = cCart.original_total_price;
    this.total_discount = cCart.original_discount;
    this.total_price = cCart.total_price;

    this.cart_level_discounts = cCart.cart_level_discount;

    /*cCart.items.foreach(item=>{
            this.items.push(await DZProductHelper.getProduct(item))
        })*/
  }
}

class DZProductHelper {
  static async getProduct(item) {
    const response = await fetch(
      `${theme.dzStrings.cFetchIso}/products/${item.handle}.js`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response.ok) {
      const cProduct = await response.json();
      const cVariant = cProduct.variants.find(
        (vari) => vari.id == item.variant_id
      );

      return new DZProduct(cProduct, cVariant, item);
    }
  }
}

class DZCurrencySelector {
  static chooseCurrency(formId, curr) {
    //console.log('chooseCurr', formId, curr)
    var form = document.forms[formId];
    //console.log(form)
    var currElement = form.elements["currency"];
    currElement.value = curr;
    //console.log(currElement)
    form.submit();
  }
}

class DZCurrencyHelper {
  static parseMoney(value, currency) {
    var moneyString = "";
    switch (currency) {
      case "EUR":
        moneyString = value.toFixed(2).replace(".", ",") + " €";

        break;

      case "USD":
        moneyString = "$" + value.toFixed(2);
        break;

      default:
        moneyString = value.toFixed(2).replace(".", ",") + " €";
        break;
    }

    return moneyString;
  }
}



function toggleReturnFields(index) {
  const radioButton = document.getElementById(`item${index}`);
  const returnFields = document.getElementById(`return-fields-${index}`);
  const allReturnFields = document.querySelectorAll('[id^="return-fields-"]');
  allReturnFields.forEach((field) => (field.style.display = "none"));
  if (radioButton.checked) {
    returnFields.style.display = "table-row";
  } else {
    returnFields.style.display = "none";
  }
}
function toggleDropdown(index) {
  const dropdown = document.getElementById(`dropdown-reason-${index}`);
  dropdown.classList.toggle("show");
}

function selectDropdownItem(index, value) {
  const dropdownSelected = document.querySelector(
    `#dropdown-reason-${index} .dropdownSelected`
  );
  const dropdown = document.getElementById(`dropdown-reason-${index}`);
  const hiddenInput = document.getElementById(`reason${index}`);

  // Update the selected item
  if (value === "1") {
    dropdownSelected.textContent = "Color/Shade mismatch";
  } else if (value === "2") {
    dropdownSelected.textContent = "Texture / Formula / Scent preference";
  } else if (value === "3") {
    dropdownSelected.textContent = "Irritation / Sensitivity";
  } else if (value === "4") {
    dropdownSelected.textContent = "Didn’t meet my expectations";
  } else if (value === "5") {
    dropdownSelected.textContent = "Ordered by mistake / no longer needed";
  }

  // Update the hidden input value
  hiddenInput.value = value;

  // Close the dropdown
  dropdown.classList.remove("show");
}
function toggleQuantityDropdown(index) {
  const dropdown = document.getElementById(`dropdown-quantity-${index}`);
  dropdown.classList.toggle("show");
}

function selectQuantityItem(index, quantity) {
  const dropdownSelected = document.querySelector(
    `#dropdown-quantity-${index} .dropdownSelected`
  );
  const dropdown = document.getElementById(`dropdown-quantity-${index}`);
  const hiddenInput = document.getElementById(`quantity${index}`);

  // Update the selected item
  dropdownSelected.textContent = `${quantity}`;

  // Update the hidden input value
  hiddenInput.value = quantity;

  // Close the dropdown
  dropdown.classList.remove("show");
}

//console.log(theme.dzStrings)
class DZAccount {
  constructor() {
    document.addEventListener("DOMContentLoaded", () => {
      this.container = document.querySelector("[data-dz-profile-container]");
      this.profileBtn = document.querySelector("[data-dz-profile-btn]");
      this.ordersBtn = document.querySelector("[data-dz-orders-btn]");

      const consultantStatusDiv = document.getElementById("consultant-status");
      const isConsultant = consultantStatusDiv
        ? JSON.parse(consultantStatusDiv.getAttribute("data-is-consultant"))
        : false;
      this.isConsultant =
        typeof isConsultant !== "undefined" ? isConsultant : false;

      this.selectedItems = [];
      this.init();
    });
  }

  static smileyReceivedSVG = `
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="16" cy="16" r="15.5" stroke="#D100CA"/>
<path d="M16.2322 25.9998C12.6716 25.9998 9.30618 24.2014 7.23018 21.1879C6.83483 20.614 6.96115 19.815 7.51398 19.4031C8.066 18.9912 8.83455 19.1234 9.23072 19.6981C10.8466 22.0423 13.4639 23.4416 16.233 23.4416C19.0325 23.4416 21.6662 22.0184 23.2788 19.6342C23.67 19.0569 24.4361 18.917 24.9931 19.3238C25.5492 19.7305 25.6829 20.5279 25.2916 21.106C23.2181 24.1707 19.8314 25.9998 16.2322 25.9998Z" fill="#D100CA"/>
<path d="M9.31171 13.78C10.3061 13.78 11.1122 12.942 11.1122 11.9082C11.1122 10.8744 10.3061 10.0364 9.31171 10.0364C8.31733 10.0364 7.51123 10.8744 7.51123 11.9082C7.51123 12.942 8.31733 13.78 9.31171 13.78Z" fill="#D100CA"/>
<path d="M23.204 13.6395C24.1707 13.6395 24.9544 12.8247 24.9544 11.8197C24.9544 10.8147 24.1707 10 23.204 10C22.2373 10 21.4536 10.8147 21.4536 11.8197C21.4536 12.8247 22.2373 13.6395 23.204 13.6395Z" fill="#D100CA"/>
</svg>
`;

  init() {
    if (!this.container) {
      return;
    }
    const location = window.location.href.split("#");
    if (location.length > 1) {
      this.fillOrders();
    } else {
      this.fillProfile();
    }
  }

  fillProfile() {
    if (default_address) {
      this.container.innerHTML = `
              <div id="contactInformation">
              <h2 class="yourProfileTitle">YOUR PROFILE</h2>
              <p class="yourProfileDesc">Here you can view and manage your user data.</p>
              <div style="padding-bottom: 35px"></div>
              <div class="profileBar"></div>
                  <div style="padding-top: 10px"></div>
                <span class="dz-pink-text dz-pointer editButtonText" style="right: 0;bottom: 0; float: right; cursor: pointer; text-decoration: underline;  text-underline-offset: 2px;"  onclick="(() => myAccount.contactInformationEdit())()" data-dz-addressitem-edit>edit</span>
                  <div style="padding-top: 10px"></div>
                <div id='customerAccountForm'>
                  <p class="accountLabels">First Name</p>
                  <p class="accountInfo">${customerFirstName}</p>
      
                  <p class="accountLabels">Last Name</p>
                  <p class="accountInfo">${customerLastName}</p>
      
                  <p class="accountLabels">E-Mail</p>
                  <p class="accountInfo">${customerEmailAddress}</p>
      
                  <p class="accountLabels">Phone Number</p>
                  <p class="accountInfo" style="margin-bottom: 30px;">${customerPhone}</p>
                </div>
              </div>
              
              <div class="profileBar"></div>
    
              <div id='passwordSection'>
                <div style="padding-top: 10px"></div>
                <span class="dz-pink-text dz-pointer editButtonText" style="right: 0;bottom: 0; float: right; cursor: pointer; text-decoration: underline;  text-underline-offset: 2px;" onclick="(() => myAccount.passwordFormFill())()"  data-dz-addressitem-edit>edit</span>
                <div style="padding-top: 10px"></div>
  
              <p class="accountPasswordLabel"> Your Password </p>
              <p class="accountPasswordText"> ************************* </p>
              </div>
              `;
    } else {
      this.container.innerHTML = `
                <p>${customer}<br>
                <br>
                ${mail}</p>
              `;
    }
    this.ordersBtn.classList.add("dz-no-text-deco");
    this.profileBtn.classList.remove("dz-no-text-deco");
  }

  fillOrders() {
    const profileButton = document.querySelector("[data-dz-profile-btn]");

    if (profileButton) {
      // Add class 'dz-no-text-deco'
      profileButton.classList.add("dz-no-text-deco");
    }

    // Look up elements with the attribute 'data-dz-orders-btn'
    const ordersButton = document.querySelector("[data-dz-orders-btn]");

    if (ordersButton) {
      // Remove class 'data-dz-orders-btn'
      ordersButton.classList.remove("dz-no-text-deco");
    }

    const filterOptions = `
          <div class="filterRow">
            <h1 class="yourOrdersHeader">YOUR ORDERS</h1>
            <div class="orderFilterSelect">
            <select id="order-filter" onchange="myAccount.filterOrders()">
              <option value="1" selected>in the last month</option>
              <option value="3">in the last 3 months</option>
              <option value="6">in the last 6 months</option>
              <option value="12">in the last year</option>
              <option value="24">in the last 2 years</option>
            </select>
            </div>
          </div>
        `;

    let content;

    if (orders.length === 0) {
      content = `
            <div>
              ${filterOptions}
              <p>You haven't ordered anything yet. <a href="/shop">Shop now :-)</a></p>
            </div>
          `;
    } else {
      content = this.generateOrdersTable(orders, filterOptions);
    }

    this.container.innerHTML = content;

    this.filterOrders();
  }

  contactInformationEdit() {
    const contactInformationSection =
      document.getElementById("contactInformation");
    var customerId = window.ShopifyAnalytics.meta.page.customerId;

    if (contactInformationSection) {
      contactInformationSection.innerHTML = editContactInformation;

      // Add the event listener after the content is added
      const saveProfileButton = document.getElementById("SaveProfile");
      if (saveProfileButton) {
        saveProfileButton.addEventListener("click", function (event) {
          event.preventDefault(); // Prevent form submission

          const firstName = document.getElementById("FirstName").value;
          const lastName = document.getElementById("LastName").value;
          const email = document.getElementById("Email").value;
          const phoneNumber = document.getElementById("PhoneNumber").value;

          // Prepare the data to send
          const data = {
            first_name: firstName,
            last_name: lastName,
            email: email,
            phone: phoneNumber,
          };

          const url = `https://sync1.connectolive.com/account/profile/${customerId}`;
          // Send the updated profile information to the API
          fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.error) {
                alert(data.error);
              } else {
                document.getElementById("addressChangeDialog").style.display =
                  "block";
              }
            })
            .catch((error) => {
              console.error("Error:", error);
              alert("An error occurred. Please try again later.");
            });
        });
      } else {
        console.error("SaveProfile button not found.");
      }
    } else {
      console.error('Element with id "contactInformation" not found.');
    }
  }

  passwordFormFill() {
    const passwordSection = document.getElementById("passwordSection");

    // Replace the HTML content of the element with the new HTML
    if (passwordSection) {
      passwordSection.innerHTML = recoverPasswordFormHTML;

      // Add the event listener after the content is added
      const recoverPasswordSubmit = document.getElementById(
        "RecoverPasswordSubmit"
      );
      if (recoverPasswordSubmit) {
        recoverPasswordSubmit.addEventListener("click", function (event) {
          event.preventDefault(); // Prevent form submission

          var email = document.getElementById("RecoverEmail").value;
          var errorElement = document.getElementById(
            "RecoverEmail-email-error"
          );

          // Prepare the data to send
          var data = {
            email: email,
          };

          // Send the email to the password recovery API
          fetch("https://sync1.connectolive.com/account/password", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          })
            .then((response) => response.json())
            .then((data) => {
              if (data.error) {
                alert(data.error);
              } else {
                alert("A password change request has been sent your email.");
                location.reload();
              }
            })
            .catch((error) => {
              console.error("Error:", error);
              alert("An error occurred. Please try again later.");
            });
        });
      } else {
        console.error("RecoverPasswordSubmit button not found.");
      }
    } else {
      console.error('Element with id "passwordSection" not found.');
    }
  }
  hidePasswordResetForm() {
    this.fillProfile();
  }

  customerAccountFormFill() {
    const customerAccountSection = document.getElementById(
      "customerAccountForm"
    );
    console.log("Inside the function!!");
    // Replace the HTML content of the element with the new HTML
    if (customerAccountSection) {
      customerAccountSection.innerHTML = customerAccountForm;
    } else {
      console.error('Element with id "customer account" not found.');
    }
  }
  generateOrdersTable(orders, filterOptions) {
    const table = document.createElement("table");

    table.innerHTML = `
          <tbody>
          ${orders
            .map((order) => {
              // Convert the date string to ISO 8601 format for Safari compatibility
              const isoDateString = order.created_at
                .replace(" ", "T")
                .replace(" -0700", "-07:00");
              const correctDateString = isoDateString.replace(" -", "-");
              const parsedDate = new Date(correctDateString);
              const formattedDate = !isNaN(parsedDate.getTime())
                ? parsedDate.toLocaleDateString("en-US")
                : "Invalid Date";

              console.log("Orginal Order date: ", order.created_at);
              console.log("ISO Date String: ", isoDateString);
              console.log("Parsed Date String: ", parsedDate);
              console.log("Formatted Date: ", formattedDate);
              return `
              <tr style="border-bottom: 1px solid #595959; border-top: 1px solid #595959;" onclick="myAccount.showOrderDetails('${
                order.order_number
              }')">
                <td style="padding: 10px 0;">
                  <div class="orderNumberText">Order number: ${
                    order.order_number
                  }</div>
                  <div class="orderQuantityText">${
                    order.line_items.length
                  } items</div>
                </td>
                <td style="padding: 10px 0;">
                  <div class="orderDetailText">${formattedDate}</div>
                  <div class="orderDetailText">${DZCurrencyHelper.parseMoney(
                    order.total_price / 100,
                    theme.dzStrings.cart.currency
                  )}</div>
                </td>
                <td style="padding: 10px 0;">
                  <div>
                    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 17L9 9L1 1" stroke="black"/>
                    </svg>
                  </div>
                </td>
              </tr>
            `;
            })
            .join("")}
          </tbody>
        `;

    return `
          <div>
            ${filterOptions}
            ${table.outerHTML}
          </div>
        `;
  }

  filterOrders() {
    const filterValue = document.getElementById("order-filter").value;
    console.log("Filter Value:", filterValue);

    const now = new Date();

    const filteredOrders = orders.filter((order) => {
      const orderDate = new Date(order.created_at);
      console.log("Order:", order);
      console.log("Order Date (parsed):", orderDate);

      // Calculate the difference in time in milliseconds
      const timeDiff = now - orderDate;

      // Convert the difference from milliseconds to months
      const monthsDiff = timeDiff / (1000 * 60 * 60 * 24 * 30.4375); // Average days per month (30.4375)

      console.log("Months Difference:", monthsDiff);

      return monthsDiff <= filterValue;
    });

    console.log("Filtered Orders:", filteredOrders);

    // Prevent re-rendering with an empty array
    if (filteredOrders.length > 0) {
      // Use cloneNode(true) to avoid issues in Chrome
      const filterOptions = document
        .querySelector(".filterRow")
        .cloneNode(true).outerHTML;
      this.container.innerHTML = this.generateOrdersTable(
        filteredOrders,
        filterOptions
      );
    } else {
      console.log("No orders to display for the selected filter.");
    }

    document.getElementById("order-filter").value = filterValue;
    console.log("Order filter input value reset to:", filterValue);
  }

  showOrderDetails(orderNumber) {
    const order = orders.find((o) => o.order_number == orderNumber);
    if (!order) {
      console.error("Order not found:", orderNumber);
      return;
    }

    const shippingAddress = order.shipping_address || {};
    const billingAddress = order.invoice_address || {};
    const paymentDetails = order.payment_details || {};

    // Function to convert date strings to ISO 8601 format and ensure compatibility across browsers
    const convertToISODate = (dateString) => {
      const isoDateString = dateString
        .replace(" ", "T")
        .replace(" -0700", "-07:00");
      const correctDateString = isoDateString.replace(" -", "-");
      return new Date(correctDateString).toISOString();
    };

    const orderCreatedAtISO = convertToISODate(order.created_at);
    const returnPeriod = this.isConsultant ? 60 : 365;

    // Calculate the return deadline using the ISO format date
    const returnDeadline = new Date(
      new Date(orderCreatedAtISO).setDate(
        new Date(orderCreatedAtISO).getDate() + returnPeriod
      )
    );
    const isWithinReturnPeriod = new Date() <= returnDeadline;

    // Convert the order creation date string to a properly formatted date
    const isoCreatedAt = order.created_at
      .replace(" ", "T")
      .replace(" -0700", "-07:00");
    const correctCreatedAtString = isoCreatedAt.replace(" -", "-");
    const parsedCreatedAt = new Date(correctCreatedAtString);
    const formattedCreatedAt = !isNaN(parsedCreatedAt.getTime())
      ? parsedCreatedAt.toLocaleDateString("en-US")
      : "Invalid Date";

    // Convert the fulfillment date string, if available
    const isoFulfillmentDate = order.fulfillment_date
      ? order.fulfillment_date.replace(" ", "T").replace(" -0700", "-07:00")
      : null;
    const correctFulfillmentString = isoFulfillmentDate
      ? isoFulfillmentDate.replace(" -", "-")
      : null;
    const parsedFulfillmentDate = correctFulfillmentString
      ? new Date(correctFulfillmentString)
      : null;

    // Convert the delivered date string, if available
    const isoDeliveredDate = order.delivered_date
      ? order.delivered_date.replace(" ", "T").replace(" -0700", "-07:00")
      : null;
    const correctDeliveredString = isoDeliveredDate
      ? isoDeliveredDate.replace(" -", "-")
      : null;
    const parsedDeliveredDate = correctDeliveredString
      ? new Date(correctDeliveredString)
      : null;

    const detailsContainer = document.createElement("div");
    detailsContainer.innerHTML = `
      <div class="order-container">
          <div class="order-header">
          <div class="returnBackArrow" id="returnBackArrow">
            <svg width="30" height="18" viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30 9L1 9" stroke="#595959" stroke-miterlimit="16"/>
                <path d="M10.6665 1L0.999836 9L10.6665 17" stroke="#595959"/>
            </svg>
          </div>
              <div>
                  <h1 class="your-order">Your Order</h1>
                  <p class="order-number">#${order.order_number}</p>
              </div>
              ${
                isWithinReturnPeriod && shippingAddress.country != "Canada"
                  ? '<p class="return-message" style="padding-left: 22px">To return items, please visit <a href="https://account.olivetreepeople.com" target="_blank">account.olivetreepeople.com</a> and follow the steps in our new return system.</p>'
                  : ""
              }
          </div>
          <div class="order-sub-header">
              <div class="payment-date">
                  <div>
                      <p class="paymentDetailsText">Payment Status</p>
                      <p class="paymentOrderDetailsText">${
                        order.financial_status
                      }</p>
                  </div>
                  <div class="right">
                      <p class="paymentDetailsText">Order date</p>
                      <p class="paymentOrderDetailsText">${formattedCreatedAt}</p>
                  </div>
              </div>
          </div>
          <div class="status">
              <div class="status-container">
                  <div class="left">
                      <div class="icon received">
                          ${this.constructor.smileyReceivedSVG}
                      </div>
                      <div class="text">
                          <p class="shipmentStatusText">Order received</p>
                      </div>
                  </div>
                  <div class="right">
                      <p class="paymentOrderDetailsText">${formattedCreatedAt}</p>
                  </div>
              </div>
              <div class="shipping-line"></div>
              <div class="status-container">
                  <div class="left">
                  ${
                    parsedFulfillmentDate
                      ? `
                <div class="icon received">
                    ${DZAccount.smileyReceivedSVG}
                </div>`
                      : `
                <div class="icon delivered"></div>`
                  }
                      <div class="text">
                          <p class="shipmentStatusText">Shipped</p>
                      </div>
                  </div>
                  <div class="right">
                      <p class="paymentOrderDetailsText">${
                        parsedFulfillmentDate
                          ? parsedFulfillmentDate.toLocaleDateString("en-US")
                          : ""
                      }</p>
                  </div>
              </div>
              <div class="shipping-line"></div>
              <div class="status-container">
                  <div class="left">
                     ${
                       parsedDeliveredDate
                         ? `
                <div class="icon received">
                    ${DZAccount.smileyReceivedSVG}
                </div>`
                         : `
                <div class="icon delivered"></div>`
                     }
                      <div class="text">
                          <p class="shipmentStatusText">Delivered</p>
                      </div>
                  </div>
                  <div class="right">
                      <p class="paymentOrderDetailsText">${
                        parsedDeliveredDate
                          ? parsedDeliveredDate.toLocaleDateString("en-US")
                          : ""
                      }</p>
                  </div>
              </div>
          </div>
          <div class="order-overview">
              <table width="500" cellspacing="0" cellpadding="0">
                  <thead>
                      <tr>
                          <th align="left" style="white-space: nowrap;">
                              <p style="font-size: 14px;">Order Overview</p>
                          </th>
                          <th>&nbsp;</th>
                      </tr>
                  </thead>
                  <tbody>
                      ${order.line_items
                        .map(
                          (item) => `
                      <tr>
                          <td style="border-top-width:1px;border-top-color:#595959;border-top-style:solid;border-bottom-width:1px;border-bottom-color:#E1E1E1;border-bottom-style:solid;padding-top:3px;padding-bottom:6px;padding-left:3px;padding-right:3px;" align="center" width="75">
                              <img src="${item.image}" alt="${
                            item.title
                          }" width="100%" height="auto" style="display: block;" />
                          </td>
                          <td style="border-top-width:1px;border-top-color:#595959;border-top-style:solid; border-bottom: 1px solid #E1E1E1">
                              <p style="font-size:13px;"><span style="font-size:14px;"><b>${
                                item.title
                              }</b></span><br><span style="color:#595959;">${
                            item.variant_size
                          }</span><br>x ${item.quantity}</p>
                          </td>
                          <td style="border-top-width:1px;border-top-color:#595959;border-top-style:solid;font-size:14px; border-bottom: 1px solid #E1E1E1; padding: 0; text-align:end" align="right" width="75"><p class="paymentOrderDetailsText">${DZCurrencyHelper.parseMoney(
                            item.final_price / 100,
                            theme.dzStrings.cart.currency
                          )}</p></td>
                      </tr>`
                        )
                        .join("")}
                  </tbody>
              </table>
          </div>
<div class="total" style="border-bottom: 1px solid #595959; padding: 10px 0;">
  <div class="label-value" style="display: flex; justify-content: space-between;">
      <p>&nbsp;</p>
      <div class="orderSummaryPriceText "><p class="label orderOverViewTotalsText">Subtotal:</p></div>
      <p class="orderOverViewTotalsText" style="width:50px">${DZCurrencyHelper.parseMoney(
        order.total_price / 100,
        theme.dzStrings.cart.currency
      )}</p>
  </div>
  <div class="label-value" style="display: flex; justify-content: space-between;">
      <p>&nbsp;</p>
      <div class="orderSummaryPriceText"><p class="label orderOverViewTotalsText">Shipping:</p></div>
      <p class="orderOverViewTotalsText" style="width:50px">${DZCurrencyHelper.parseMoney(
        order.shipping / 100,
        theme.dzStrings.cart.currency
      )}</p>
  </div>
  <div class="label-value" style="display: flex; justify-content: space-between;">
      <p>&nbsp;</p>
      <div class="orderSummaryPriceText"><p class="label orderOverViewTotalsText">Discounts:</p></div>
      <p class="orderOverViewTotalsText" style="width:50px">${DZCurrencyHelper.parseMoney(
        order.discounts / 100,
        theme.dzStrings.cart.currency
      )}</p>
  </div>
      <div class="label-value" style="display: flex; justify-content: space-between;">
      <p>&nbsp;</p>
      <div class="orderSummaryPriceText" ><p class="label orderOverViewTotal">Total:</p></div>
      <p class="orderOverViewTotal">${DZCurrencyHelper.parseMoney(
        order.total_price / 100,
        theme.dzStrings.cart.currency
      )}</p>
  </div>

</div>

          <div class="shipping-info">
              <h3>Shipping Address</h3>
              <p>${shippingAddress.name || ""}<br>${
      shippingAddress.address1 || ""
    }<br>${shippingAddress.city || ""} ${shippingAddress.zip || ""}<br>${
      shippingAddress.country || ""
    }</p>
              <h3>Invoice Address</h3>
              <p>${billingAddress.name || ""}<br>${
      billingAddress.address1 || ""
    }<br>${billingAddress.city || ""} ${billingAddress.zip || ""}<br>${
      billingAddress.country || ""
    }</p>
              <h3>Shipping</h3>
              <p>Standard</p>
                       </div>
      </div>
    `;

    this.container.firstElementChild.replaceWith(detailsContainer);

    if (isWithinReturnPeriod && shippingAddress.country != "Canada") {
      document
        .querySelector(".return-button")
        .addEventListener("click", () => this.showReturnPage(order));
    }
    document
      .getElementById("returnBackArrow")
      .addEventListener("click", () => this.fillOrders());
  }

  showReturnPage(order) {
    console.log("customer returns page: ", customerReturns);

    const returnPeriod = this.isConsultant ? 60 : 365;
    const excludedSkus = [
      "80065",
      "80064",
      "80064",
      "25GIFTCARD",
      "50GIFTCARD",
      "75GIFTCARD",
      "100GIFTCARD",
      "150GIFTCARD",
      "200GIFTCARD",
      "250GIFTCARD",
      "300GIFTCARD",
      "350GIFTCARD",
      "MeditationMemberShip100",
    ];

    //Old line without 0.00 condition
    // const returnableItems = order.line_items.filter(item => item.sku && !excludedSkus.includes(item.sku));

    // Identify free gift items correctly
    const isFreeGiftOrder = order.line_items.some(
      (item) =>
        parseFloat(item.final_price) === 0.0 &&
        (!item.tags || !item.tags.includes("NOTAGIFT"))
    );

    const returnableItems = order.line_items.filter(
      (item) =>
        item.sku &&
        !excludedSkus.includes(item.sku) &&
        parseFloat(order.total_price) !== 0.0
    );

    // Convert the order creation date to ISO format for Safari compatibility
    const isoCreatedAt = order.created_at
      .replace(" ", "T")
      .replace(" -0700", "-07:00");
    const correctCreatedAtString = isoCreatedAt.replace(" -", "-");
    const parsedCreatedAt = new Date(correctCreatedAtString);

    // Calculate the return deadline date
    const returnDeadlineDate = new Date(parsedCreatedAt);
    returnDeadlineDate.setDate(returnDeadlineDate.getDate() + returnPeriod);

    // Format the return deadline date for display
    const formattedReturnDeadline = !isNaN(returnDeadlineDate.getTime())
      ? returnDeadlineDate.toLocaleDateString("en-US")
      : "Invalid Date";

    // Check if customerReturns is valid and has items
    const returnedItems =
      customerReturns && Array.isArray(customerReturns)
        ? customerReturns
            .map((returnedItem) => {
              const matchedItem = order.line_items.find(
                (item) => item.sku === returnedItem.sku
              );
              return matchedItem
                ? {
                    ...matchedItem,
                    tracking_number: returnedItem.tracking_number,
                    tracking_url: returnedItem.tracking_url,
                  }
                : null;
            })
            .filter((item) => item !== null)
        : []; // If customerReturns is null, undefined, or not an array, return an empty array

    const returnContainer = document.createElement("div");
    returnContainer.innerHTML = `<div class="register-return-container">
        <div class="register-return-header">
            <h1 class="registerReturnHeader">REGISTER YOUR RETURN</h1>
            <p class="registerReturnOrderNo">Order No. ${order.order_number}</p>
            <p class="registerReturnOrderDetailsText" style="margin-bottom:0px;">Return eligible through ${formattedReturnDeadline}</p>
            <p class="registerReturnOrderDetailsText">Select the items you wish to return and the reason for the return.</p>
            ${
              isFreeGiftOrder
                ? '<p class="bundleReturnNotice"><strong>Bundles must be returned as a complete set.</strong></p>'
                : ""
            }
        </div>
        <div class="register-return-overview">
            <table cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <th align="left" style="white-space: nowrap;">
                            <p style="font-size: 14px;">Order Overview</p>
                        </th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    ${returnableItems
                      .map((item, index) => {
                        const isReturned = returnedItems.some(
                          (returnedItem) => returnedItem.sku === item.sku
                        );
                        return `
                        <tr id="return-item-row-${index}" style="${
                          isReturned ? "display: none;" : ""
                        }">
                            <td class="left-column-return-register" align="center" width="10">
                                <input type="checkbox" 
       id="item${index}" 
       name="returnItem" 
       onchange="myAccount.toggleReturnFields(${index})"
       ${isFreeGiftOrder ? "checked disabled" : ""}>

                            </td>
                            <td class="register-return-item-details" >
                                <img src="${item.image}" alt="${
                          item.title
                        }" width="50" height="auto" />
                                <div class="register-return-item-info">
                                    <div>
                                        <p style="font-size:14px;"><b>${
                                          item.title
                                        }</b></p>
                                        <p style="color:#595959;">${
                                          item.variant_size
                                        }</p>
                                        <p>x ${item.quantity}</p>
                                    </div>
                                </div>
                            </td>
                            <td class="register-return-item-price" align="right" width="75">
                                <p class="paymentOrderDetailsText">${DZCurrencyHelper.parseMoney(
                                  item.final_price / 100,
                                  theme.dzStrings.cart.currency
                                )}</p>
                            </td>
                        </tr>
                        <tr id="return-fields-${index}" style="display: ${
                          isFreeGiftOrder ? "table-row" : "none"
                        };">

                            <td colspan="3">
                                <div class="return-form-row">
                                    <div class="return-form-group">
                                        <!-- Return reason dropdown -->
                                        <div class="dropdownContainer" id="dropdown-reason-${index}">
                                            <div class="dropdownSelected" onclick="toggleDropdown(${index})">
                                                Select reason for return
                                            </div>
                                            <div class="dropdownList" id="dropdown-list-${index}">
                                                <div class="dropdownItem" onclick="selectDropdownItem(${index}, '1')">Color/Shade mismatch</div>
                                                <div class="dropdownItem" onclick="selectDropdownItem(${index}, '2')">Texture / Formula / Scent preference</div>
                                                <div class="dropdownItem" onclick="selectDropdownItem(${index}, '3')">Irritation / Sensitivity</div>
                                                <div class="dropdownItem" onclick="selectDropdownItem(${index}, '4')">Didn’t meet my expectations</div>
                                                <div class="dropdownItem" onclick="selectDropdownItem(${index}, '5')">Ordered by mistake / no longer needed</div>
                                            </div>
                                        </div>
                                        <input type="hidden" id="reason${index}" value="">
                                    </div>
                        
                                    <!-- Quantity dropdown -->
                                    <div class="return-form-group return-quantity-group quantityBox">
                                        <div class="dropdownContainer" id="dropdown-quantity-${index}">
                                            <div class="dropdownSelected" onclick="toggleQuantityDropdown(${index})">
                                                1
                                            </div>
                                            <div class="dropdownList" id="dropdown-quantity-list-${index}">
                                                ${Array.from(
                                                  { length: item.quantity },
                                                  (_, i) =>
                                                    `<div class="dropdownItem" onclick="selectQuantityItem(${index}, ${
                                                      i + 1
                                                    })">${i + 1}</div>`
                                                ).join("")}
                                            </div>
                                        </div>
                                        <input type="hidden" id="quantity${index}" value="1">
                                    </div>
                                </div>
                        
                                <!-- Comments -->
                                <div class="return-form-group">
                                    <textarea id="comments${index}" rows="4" class="returnsCommentBox" placeholder="Comments (required)" maxlength="250"></textarea>
                                </div>
                                
                              <p class="returnAlert">Note: We aren’t able to offer policy exceptions in response to comments.</p>

                            </td>
                        </tr>
                      `;
                      })
                      .join("")}
                </tbody>
            </table>
        </div>

        ${
          returnedItems.length > 0
            ? `
        <div class="returned-items-overview">
            <h2 class="yourReturnText">Returned Items</h2>
            <table cellspacing="0" cellpadding="0">
                <thead>
                    <tr>
                        <th align="left" style="white-space: nowrap;">
                            <p style="font-size: 12px;text-wrap: pretty; font-weight: 400">The following items below, are items that have been returned from your order. You can see the tracking information and re-download the label.</p>
                        </th>
                        <th>&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    ${returnedItems
                      .map(
                        (item) => `
                      <tr>
                          <td style="border-top-width:1px;border-top-color:#595959;border-top-style:solid;border-bottom-width:1px;border-bottom-color:#595959;border-bottom-style:solid;padding:10px 0;">
                              <div class="register-return-item-info">
                                  <img src="${
                                    item.image
                                  }" class="returnedItemPhoto" alt="${
                          item.title
                        }" width="50" height="auto" />
                                  <div>
                                      <p class="returnTextProductTitle"><b>${
                                        item.title
                                      }</b></p>
                                      <p style="color:#595959;">${
                                        item.variant_size
                                      }</p>
                                      <p>x ${item.quantity}</p>
                                      ${
                                        item.tracking_url.includes("shippo")
                                          ? `<p>Tracking Number: ${item.tracking_number}</p>
                                             <p><a href="${item.tracking_url}" target="_blank">Return Label</a></p>`
                                          : `<p>Tracking: <a href="${item.tracking_url}" target="_blank">${item.tracking_number}</a></p>`
                                      }
                                  </div>
                              </div>
                          </td>
                          <td class="register-return-item-price" style="border-top-width:1px;border-top-color:#595959;border-top-style:solid;font-size:14px; border-bottom: 1px solid #595959; text-align:right;" align="right" width="75">
                              <p class="paymentOrderDetailsText">${DZCurrencyHelper.parseMoney(
                                item.final_price / 100,
                                theme.dzStrings.cart.currency
                              )}</p>
                          </td>
                      </tr>`
                      )
                      .join("")}
                </tbody>
            </table>
        </div>`
            : ""
        }
        <a href="#" class="continue-button">CONTINUE</a>
    </div>`;

    this.container.innerHTML = returnContainer.innerHTML;
    document
      .querySelector(".continue-button")
      .addEventListener("click", () => this.handleReturnSelection(order));
    document.querySelector(".register-return-item-details").style.borderTop =
      "1px solid #ccc";

    // Automatically trigger the toggle function for all items if a free gift is present
    if (isFreeGiftOrder) {
      returnableItems.forEach((_, index) =>
        this.toggleReturnFields(index, true)
      );
    }
  }

  toggleReturnFields(index) {
    const checkbox = document.getElementById(`item${index}`);
    const returnFields = document.getElementById(`return-fields-${index}`);
    const itemIndex = this.selectedItems.findIndex(
      (item) => item.index === index
    );

    if (checkbox.checked) {
      if (itemIndex === -1) {
        this.selectedItems.push({ index });
      }
      returnFields.style.display = "table-row";
    } else {
      if (itemIndex !== -1) {
        this.selectedItems.splice(itemIndex, 1);
      }
      returnFields.style.display = "none";
    }

    document.querySelectorAll(
      ".register-return-item-details"
    )[1].style.borderTop = "1px solid #ccc";
  }

  handleReturnSelection(order) {
    const selectedItems = [];
    order.line_items.forEach((item, index) => {
      const checkbox = document.getElementById(`item${index}`);
      if (checkbox && checkbox.checked) {
        const reason = document.getElementById(`reason${index}`).value;
        const quantity = document.getElementById(`quantity${index}`).value;
        const comments = document.getElementById(`comments${index}`).value;
        if (reason && quantity > 0 && comments) {
          selectedItems.push({
            ...item,
            reason,
            quantity,
            comments,
          });
        }
      }
    });

    if (selectedItems.length === 0) {
      alert("Please select items to return and fill in all required fields.");
      return;
    }

    this.showReturnConfirmationPage(order, selectedItems);
  }

  async showReturnConfirmationPage(order, selectedItems) {
    const returnPeriod = this.isConsultant ? 60 : 365;

    // Mapping of reason values to their corresponding texts
    const reasonMap = {
      1: "Color/Shade mismatch",
      2: "Texture / Formula / Scent preference",
      3: "Irritation / Sensitivity",
      4: "Didn’t meet my expectations",
      5: "Ordered by mistake / no longer needed"
    };
    const returnDetailsHTML = selectedItems
      .map((item) => {
        const reasonText = reasonMap[item.reason] || "Unknown reason";
        return `
          <div class="return-details">
              <div class="yourReturnText">Your return:</div>
              <img src="${item.image}" alt="Product Image">
              <div class="returnSummaryRow">
                  <div class="returnTextProductTitle">${item.title}</div>
                  <div class="yourReturnItemListText">${item.variant_size}</div>
                  <div class="yourReturnItemListText">x ${item.quantity}</div>
                  <div class="yourReturnItemListText">Reason for return: ${reasonText}</div>
                  <div class="yourReturnItemListText">Comments: ${item.comments}</div>
              </div>
          </div>
        `;
      })
      .join("");

    // Correcting the date string for Safari compatibility
    const isoCreatedAt = order.created_at
      .replace(" ", "T")
      .replace(" -0700", "-07:00");
    const correctCreatedAtString = isoCreatedAt.replace(" -", "-");
    const parsedCreatedAt = new Date(correctCreatedAtString);

    // Calculate the return deadline date
    const returnDeadlineDate = new Date(parsedCreatedAt);
    returnDeadlineDate.setDate(returnDeadlineDate.getDate() + returnPeriod);

    // Format the return deadline date for display
    const formattedReturnDeadline = !isNaN(returnDeadlineDate.getTime())
      ? returnDeadlineDate.toLocaleDateString("en-US")
      : "Invalid Date";

    const returnConfirmationHTML = `
          <div class="container">
            <div class="registerReturnHeader">CHOOSE A RETURN OPTION</div>
            <div class="order-info" style="disply: flex; flex-flow: column; align-items: start">
                <p class="registerReturnOrderNo" style="margin: 0">Order No. ${
                  order.order_number
                }</p>
                <p class="registerReturnOrderDetailsText">Return eligible through ${formattedReturnDeadline}</p>
            </div>
            
            <div class="return-option">
                <input type="checkbox" id="shippingOptionRadio">
                <label for="shippingOptionLabel">
                    <img src="https://uspsblog.com/wp-content/uploads/2015/11/USPS_Eagle-Symbol-web-size-300x253.png" alt="USPS Logo"> USPS Printable Label
                </label>
            </div>
            ${returnDetailsHTML}
            <div class="refund-summary">
              <div class="summaryOfRefundText">Summary of the refund:</div>
                <div style="display: flex; flex-flow: column;  align-items: self-end;">
                  <div class="refundSummaryText">Subtotal of the refund: $${selectedItems
                    .reduce(
                      (sum, item) =>
                        sum + (item.final_price / 100) * item.quantity,
                      0
                    )
                    .toFixed(2)}</div>
                  <div class="refundSummaryText">Shipping:<span class="shippingAmountText"> $7.00</span></div>
                  <div> <span class="expectedRefundAmount"> Expected refund amount:  $${(
                    selectedItems.reduce(
                      (sum, item) =>
                        sum + (item.final_price / 100) * item.quantity,
                      0
                    ) - 7
                  ).toFixed(2)}</span></div>
                </div>
          </div>
           <button id="confirmReturnButton" class="confirm-button">CONFIRM RETURN</button>
          </div>
        `;

    this.container.innerHTML = returnConfirmationHTML;

    document
      .querySelector(".confirm-button")
      .addEventListener("click", async (e) => {
        e.preventDefault();

        // Disable the button to prevent multiple clicks
        const confirmButton = e.target;
        confirmButton.disabled = true;
        confirmButton.textContent = "Processing..."; // Optionally change the button text to indicate processing

        const returnData = {
          order_id: order.order_id,
          orderNumber: order.order_number,
          shippingAddress: order.shipping_address,
          returnItems: selectedItems.map((item) => {
            const reasonText = reasonMap[item.reason] || "Unknown reason"; // Get the text for the reason
            return {
              title: item.title,
              variant_size: item.variant_size,
              quantity: item.quantity,
              sku: item.sku,
              reason: item.reason,
              comments: reasonText + " : " + item.comments, // Use reasonText here
            };
          }),
        };

        try {
          const response = await fetch(
            "https://sync1.connectolive.com/checkReturns",
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(returnData),
            }
          );

          if (!response.ok) {
            throw new Error("Network response was not ok");
          }

          const result = await response.json();

          if (result.label_url) {
            this.showLabelDownloadPage(result.label_url);
          } else {
            alert(result.error || "An unknown error occurred.");
          }
        } catch (error) {
          console.error("Error processing return:", error);
          alert("There was an error processing your return. Please try again.");
        } finally {
          confirmButton.disabled = false; // Optionally re-enable the button in case of an error
          confirmButton.textContent = "CONFIRM RETURN"; // Reset the button text if needed
        }
      });
  }

  showLabelDownloadPage(labelUrl) {
    this.container.innerHTML = `
            <div class="label-download-page">
                <h1 class="requestReceivedHeader">Your request has been received</h1>
                <p class="requestReceivedBody">Thank you for registering your return!</p>
                <p class="requestReceivedBody">Pack all the items you have registered for return in a bag / box. Use the below label for this package, which you can download & print below.</p>
                <br>
                <p class="requestReceivedBody">To ensure a smooth return process, please note that our return labels are valid for 14 days from the date they are issued. We kindly ask that you use the label within this timeframe.</p>

                <p style="text-align: center; text-align: -webkit-center">
                
                <a href="${labelUrl}" target="_blank" class="label-download-button">LABEL DOWNLOAD</a></p>
            </div>
        `;
  }
}

var myAccount = new DZAccount();
myAccount.init();

class DZAddress {
  constructor() {
    this.addresses = [];
    this.selectors = {
      addressItems: "[data-dz-addressitem]",
      addressData: "[data-dz-addressdata]",
      addressForm: "[data-dz-addressform]",
    };
  }

  init() {
    this.addresses = document.querySelectorAll(this.selectors.addressItems);
  }

  editAddress(id) {
    var cAddressItem = Array.from(this.addresses).find(
      (address) => address.dataset.dzAddressitem == id
    );
    if (!cAddressItem) {
      return;
    }

    var cAddressData = cAddressItem.querySelector(this.selectors.addressData);
    var cAddressForm = cAddressItem.querySelector(this.selectors.addressForm);

    cAddressData.classList.remove("d-block");
    cAddressData.classList.add("d-none");

    cAddressForm.classList.add("d-block");
    cAddressForm.classList.remove("d-none");
  }

  cancelEdit(id) {
    //console.log(id)
    var cAddressItem = Array.from(this.addresses).find(
      (address) => address.dataset.dzAddressitem == id
    );
    if (!cAddressItem) {
      return;
    }

    var cAddressData = cAddressItem.querySelector(this.selectors.addressData);
    var cAddressForm = cAddressItem.querySelector(this.selectors.addressForm);

    cAddressData.classList.add("d-block");
    cAddressData.classList.remove("d-none");

    cAddressForm.classList.remove("d-block");
    cAddressForm.classList.add("d-none");
  }
}
const myAddresses = new DZAddress();
myAddresses.init();

class DZExport {
  static exportCategories(cats) {
    var rows = new Array();
    cats.forEach((cat, k) => {
      rows.push([k, cat.title]);
    });
    let csvContent = "data:text/csv;charset=utf-8,\r\n";

    rows.forEach(function (rowArray) {
      let row = rowArray.join(",");
      csvContent += row + "\r\n";
    });

    //console.log(csvContent)

    var encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "my_data.csv");
    document.body.appendChild(link); // Required for FF

    link.click();
  }
}

var jdgmetext = document.querySelector(".jdgm-rev-widg__header");
if (jdgmetext) {
  //console.log('review')
  var reviewText = document.createElement("h2");
  reviewText.classList.add("dz-review-title");
  reviewText.innerHTML = theme.dzStrings.recommendationText;
  jdgmetext.prepend(reviewText);
} else {
  //console.log('no review')
}

$(document).ready(function () {
  $("#shopify-section-cart-otp form input.product-form__input").keypress(
    function (e) {
      var keycode = e.keyCode ? e.keyCode : e.which;

      if (keycode == "13") {
        e.preventDefault();
        console.log("cart work started");
        $(this).parents("form").addClass("loading");
        $(this)
          .parents("form")
          .append(
            '<span class="loader"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"></path></svg></span>'
          );

        cartSubmitCustomUpdate(this);
      }
    }
  );

  $("#shopify-section-cart-otp form input[name='update']").on(
    "click",
    function (e) {
      e.preventDefault();
      console.log("cart work started");
      $(this).parents("form").addClass("loading");
      $(this)
        .parents("form")
        .append(
          '<span class="loader"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-spinner" viewBox="0 0 20 20"><path d="M7.229 1.173a9.25 9.25 0 1 0 11.655 11.412 1.25 1.25 0 1 0-2.4-.698 6.75 6.75 0 1 1-8.506-8.329 1.25 1.25 0 1 0-.75-2.385z" fill="#919EAB"></path></svg></span>'
        );

      cartSubmitCustomUpdate(this);
    }
  );

  // Reset Password Form page
  $(".reset-password-form-wrapper form .show-pw").on("click", function (e) {
    e.preventDefault();
    $(this).parent().find("input").attr("type", "text");
    $(this).addClass("hide");
    $(this).parent().find(".hide-pw").removeClass("hide");
  });
  $(".reset-password-form-wrapper form .hide-pw").on("click", function (e) {
    e.preventDefault();
    $(this).parent().find("input").attr("type", "password");
    $(this).addClass("hide");
    $(this).parent().find(".show-pw").removeClass("hide");
  });
});

async function cartSubmitCustomUpdate(element) {
  var cartElements = document.querySelectorAll(
    "input.product-form__input--quantity"
  );

  for (const item of cartElements) {
    await cartElementCustomUpdate(item);
  }

  location.reload();
}

async function cartElementCustomUpdate(ele) {
  if ($(ele).val() == 0) {
    var removeID = $(ele).data("id");

    const cCart = await CartHelper.getCart();
    var curr = $("#shopify-section-cart-otp form").data("curr-isocode");

    var cItem = cCart.items.find((item) => item.id == removeID);

    var gift_cart_f09_num = 0,
      gift_cart_f06_num = 0;
    for (var i = 0; i < cCart.items.length; i++) {
      if (
        typeof cCart.items[i].properties !== "undefined" &&
        cCart.items[i].properties
      ) {
        if (typeof cCart.items[i].properties.brain_product !== "undefined") {
          if (
            cCart.items[i].properties.brain_product == true &&
            cCart.items[i].properties.brain_gift_id > 0
          ) {
            if (cCart.items[i].properties.brain_gift_id === 42059692835011)
              gift_cart_f09_num++;
            if (cCart.items[i].properties.brain_gift_id === getGiftVariantId())
              gift_cart_f06_num++;
          }
        }
      }
    }

    if (typeof cItem !== "undefined") {
      if (typeof cItem.properties !== "undefined") {
        if (cItem.properties) {
          if (typeof cItem.properties.brain_product !== "undefined") {
            if (
              cItem.properties.brain_product == true &&
              cItem.properties.brain_gift_id > 0
            ) {
              if (
                cCart.items.find((item) => item.id === 42059692835011) &&
                cItem.properties.brain_gift_id === 42059692835011
              ) {
                // F09 Gift Product
                if (gift_cart_f09_num === 3) {
                  await CartHelper.autoRemoveFromCart(42059692835011, curr);
                  await CartHelper.autoAddToCart(39806926422211, 1, curr); //Add F09 Product to the cart
                }
              }
              if (
                cCart.items.find((item) => item.id === getGiftVariantId()) &&
                cItem.properties.brain_gift_id === getGiftVariantId()
              ) {
                // F64 Gift Product
                if (gift_cart_f06_num === 3) {
                  await CartHelper.autoRemoveFromCart(getGiftVariantId(), curr);
                  await CartHelper.autoAddToCart(39806952505539, 1, curr); //Add F64 Product to the cart
                }
              }
            }
          }
        }
      }
    }

    await CartHelper.autoRemoveFromCart(removeID, curr);
  } else {
    await CartHelper.autoUpdateCart($(ele).data("id"), $(ele).val(), curr);
  }
}

  async function forceRefreshCartPopup() {
  try {
    const response = await fetch("/cart.js", {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      cache: "no-store",
    });

    if (!response.ok) {
      console.log("Failed to refresh cart popup");
      return;
    }

    const cart = await response.json();

    // Update cart counts
    document
      .querySelectorAll("[data-dz-header-cart-count], [data-dz-cartpopup-count]")
      .forEach((el) => {
        el.innerText = cart.item_count;
      });

    // Update subtotal
    const sumEl = document.querySelector("[data-dz-cartpopup-sum]");
    if (sumEl) {
      sumEl.innerText = DZCurrencyHelper.parseMoney(
        cart.total_price / 100,
        cart.currency
      );
    }

    // Update each line item
    cart.items.forEach((item) => {

      console.log("ITEM PRICE DEBUG", {
    final_price: item.final_price,
    final_line_price: item.final_line_price,
    original_price: item.original_price,
    original_line_price: item.original_line_price,
    discounts: item.discounts,
    line_level_discount_allocations: item.line_level_discount_allocations,
    item: item
  });
  
      const itemEl = document.querySelector(
        `[data-dz-cartpopup-item="${item.id}"]`
      );

      if (!itemEl) return;

      // Quantity
      const qtyEl = itemEl.querySelector(
        "[data-dz-cartpopup-item-qty]"
      );

      if (qtyEl) {
        qtyEl.innerText = item.quantity;
      }

      // Price
      const priceEl = itemEl.querySelector(
        "[data-cart-live-price]"
      );

      if (priceEl) {
        console.log("FORCE REFRESH PRICE", {
  line_price: item.line_price,
  final_price: item.final_price,
  final_line_price: item.final_line_price,
  rendered_price: DZCurrencyHelper.parseMoney(
    item.line_price / 100,
    cart.currency
  ),
  item: item
});

        priceEl.innerText = DZCurrencyHelper.parseMoney(
         item.final_line_price / 100,
          cart.currency
        );
      }
    });

    // Empty cart handling
    if (cart.item_count === 0) {
      popupCart.emptyText.classList.remove("d-none");
      popupCart.notemptyText.classList.add("d-none");
      popupCart.subemptyText.classList.remove("d-none");
      popupCart.subnotemptyText.classList.add("d-none");
      popupCart.emptyline.classList.remove("d-none");
    } else {
      popupCart.emptyText.classList.add("d-none");
      popupCart.notemptyText.classList.remove("d-none");
      popupCart.subemptyText.classList.add("d-none");
      popupCart.subnotemptyText.classList.remove("d-none");
      popupCart.emptyline.classList.add("d-none");
    }

  } catch (err) {
    console.log("forceRefreshCartPopup error", err);
  }
}
